/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: any; output: any };
  Currency: { input: any; output: any };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export enum Action {
  ConfirmSelection = "ConfirmSelection",
  ConfirmViaPartialConfirm = "ConfirmViaPartialConfirm",
  DeclineOptInViaCatalog = "DeclineOptInViaCatalog",
  DeclineOptInViaConfirmDecline = "DeclineOptInViaConfirmDecline",
  DeclineOptInViaSigningService = "DeclineOptInViaSigningService",
  DeclineOptInViaSurvey = "DeclineOptInViaSurvey",
  EditSelectionsViaPartialConfirm = "EditSelectionsViaPartialConfirm",
  GetStarted = "GetStarted",
  GoBackViaCardOneLearnMore = "GoBackViaCardOneLearnMore",
  GoBackViaCardTwoLearnMore = "GoBackViaCardTwoLearnMore",
  GoBackViaConfirmDecline = "GoBackViaConfirmDecline",
  GoBackViaDeclineResponse = "GoBackViaDeclineResponse",
  GoBackViaFaq = "GoBackViaFaq",
  GoBackViaPartialConfirm = "GoBackViaPartialConfirm",
  GoBackViaSurveyDecline = "GoBackViaSurveyDecline",
  GoToCatalogViaFaq = "GoToCatalogViaFaq",
  GoToFaqViaCardOneLearnMore = "GoToFaqViaCardOneLearnMore",
  GoToFaqViaCardTwoLearnMore = "GoToFaqViaCardTwoLearnMore",
  GoToFaqViaConfirmDecline = "GoToFaqViaConfirmDecline",
  GoToFaqViaNavBar = "GoToFaqViaNavBar",
  GoToSongtradrViaDeclineResponse = "GoToSongtradrViaDeclineResponse",
  GoToSongtradrViaSigned = "GoToSongtradrViaSigned",
  OpenLearnMoreViaCardOne = "OpenLearnMoreViaCardOne",
  OpenLearnMoreViaCardTwo = "OpenLearnMoreViaCardTwo",
  SelectCardTwo = "SelectCardTwo",
  SelectClaimOnMonetizationSelect = "SelectClaimOnMonetizationSelect",
  SelectDoNotClaimOnMonetizationSelect = "SelectDoNotClaimOnMonetizationSelect",
  SendSignedMsaProfileToMusicBus = "SendSignedMsaProfileToMusicBus",
  SendSignedMsaProfileToMusicBusFailure = "SendSignedMsaProfileToMusicBusFailure",
  SendSongs = "SendSongs",
  SendSongsFailure = "SendSongsFailure",
  SignForm = "SignForm",
  UnselectCardTwo = "UnselectCardTwo",
  UpdatedPersonalData = "UpdatedPersonalData",
  ViewSignedDocumentViaSigned = "ViewSignedDocumentViaSigned",
}

export type AddClientInput = {
  /** Client contact */
  contact: Scalars["String"]["input"];
  /** Client email */
  email: Scalars["String"]["input"];
  /** Client name */
  name: Scalars["String"]["input"];
};

export type Artist = {
  __typename?: "Artist";
  artworkGuid?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  stats?: Maybe<ArtistStats>;
  trackIds?: Maybe<Array<Scalars["String"]["output"]>>;
  tracks?: Maybe<Array<Track>>;
};

export type ArtistImageUrlArgs = {
  size?: InputMaybe<Scalars["String"]["input"]>;
};

export type ArtistTracksArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ArtistQueries = {
  __typename?: "ArtistQueries";
  /** Get an artist by id */
  byId?: Maybe<Artist>;
  /** Shared artist queries */
  shared?: Maybe<SharedArtistQueries>;
};

export type ArtistQueriesByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type ArtistStats = {
  __typename?: "ArtistStats";
  albumsCount: Scalars["Int"]["output"];
  duration: Scalars["Int"]["output"];
  mostCommonGenre?: Maybe<Scalars["String"]["output"]>;
  segmentTracksCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
};

export type ArtistsQueries = {
  __typename?: "ArtistsQueries";
  /** Get recently played artists derived from recently played tracks */
  recent?: Maybe<Array<Artist>>;
};

export type ArtistsQueriesRecentArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AudioUrls = {
  __typename?: "AudioUrls";
  high: Scalars["String"]["output"];
  low: Scalars["String"]["output"];
  normal: Scalars["String"]["output"];
  veryHigh: Scalars["String"]["output"];
};

export type BriefAnalysis = {
  __typename?: "BriefAnalysis";
  /** Brief analysis */
  description: Scalars["String"]["output"];
  /** Filter */
  filter?: Maybe<Array<SearchFilterOutput>>;
};

export type BulkDownload = {
  __typename?: "BulkDownload";
  /** Download link for the archive, present once the job is completed */
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  /** Bulk-download job ID */
  id: Scalars["ID"]["output"];
  /** Current processing status */
  status: BulkDownloadStatus;
};

export enum BulkDownloadReferenceFormat {
  Mp3 = "mp3",
  Wav = "wav",
}

export enum BulkDownloadReferenceType {
  Playlist = "playlist",
  Track = "track",
}

export enum BulkDownloadStatus {
  Completed = "completed",
  Error = "error",
  Processing = "processing",
}

export type Channel = {
  __typename?: "Channel";
  changeDate?: Maybe<Scalars["DateTime"]["output"]>;
  channelTitle?: Maybe<Scalars["String"]["output"]>;
  /** Collections this channel belongs to */
  collections?: Maybe<Array<Collection>>;
  createDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User who connected the channel */
  createUser?: Maybe<SsoUser>;
  handle?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  /** Whether the channel was imported from old Studio, so has no createUser */
  imported?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  platform: ChannelPlatform;
  url?: Maybe<Scalars["String"]["output"]>;
  userId?: Maybe<Scalars["String"]["output"]>;
};

export type ChannelLookupError = {
  __typename?: "ChannelLookupError";
  url: Scalars["String"]["output"];
};

export type ChannelLookupInput = {
  name: Scalars["String"]["input"];
  platform: ChannelPlatform;
  url: Scalars["String"]["input"];
};

export enum ChannelPlatform {
  Facebook = "facebook",
  Instagram = "instagram",
  Other = "other",
  Tiktok = "tiktok",
  X = "x",
  Youtube = "youtube",
}

export enum ChannelSortKey {
  Handle = "handle",
  Name = "name",
  Platform = "platform",
  RecentlyAdded = "recentlyAdded",
}

export type ChannelsPage = {
  __typename?: "ChannelsPage";
  items: Array<Channel>;
  total: Scalars["Int"]["output"];
};

export type ChannelsQueries = {
  __typename?: "ChannelsQueries";
  /** Get single channel by id */
  byId?: Maybe<Channel>;
  /** Get the org's connected channels by id, in the order the ids were given */
  byIds?: Maybe<Array<Channel>>;
  /** Get the org's connected channels */
  connected?: Maybe<ChannelsPage>;
  /** Get the org's deactivated channels */
  deactivated?: Maybe<ChannelsPage>;
  /** Get user-entered channels prepared for connection (resolve metadata and flag duplicates) */
  prepared?: Maybe<Array<PreparedChannelResult>>;
};

export type ChannelsQueriesByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type ChannelsQueriesByIdsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type ChannelsQueriesConnectedArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platforms?: InputMaybe<Array<ChannelPlatform>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ChannelsSort>;
};

export type ChannelsQueriesDeactivatedArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platforms?: InputMaybe<Array<ChannelPlatform>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ChannelsSort>;
};

export type ChannelsQueriesPreparedArgs = {
  input: Array<ChannelLookupInput>;
};

export type ChannelsSort = {
  direction: SortDirection;
  key?: InputMaybe<ChannelSortKey>;
};

export type Clearance = {
  __typename?: "Clearance";
  /** Client ID */
  clientId: Scalars["ID"]["output"];
  /** Client name */
  clientName?: Maybe<Scalars["String"]["output"]>;
  /** Clearance end date */
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Clearance ID */
  id: Scalars["ID"]["output"];
  /** Clearance media (channel/video) */
  media: ClearanceMedia;
  /** Clearance Notes */
  notes?: Maybe<Scalars["String"]["output"]>;
  /** Clearance start date */
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Clearance status */
  status: ClearanceStatus;
};

export type ClearanceCreateInput = {
  /** Client ID */
  clientId: Scalars["ID"]["input"];
  /** Clearance end date */
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Clearance media (channel/video) */
  media: ClearanceMediaCreateInput;
  /** Clearance Notes */
  notes?: InputMaybe<Scalars["String"]["input"]>;
  /** Clearance start date */
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Clearance status */
  status: ClearanceStatus;
};

export type ClearanceMedia = {
  __typename?: "ClearanceMedia";
  /** Media ID (channel/video id) */
  id: Scalars["String"]["output"];
  /** Media platform */
  platform: ClearanceMediaPlatform;
  /** Media type */
  type: ClearanceMediaType;
  /** Media url */
  url: Scalars["String"]["output"];
};

export type ClearanceMediaCreateInput = {
  /** Media ID (channel/video id) */
  id: Scalars["String"]["input"];
  /** Media platform */
  platform: ClearanceMediaPlatform;
  /** Media type */
  type: ClearanceMediaType;
  /** Media url */
  url: Scalars["String"]["input"];
};

export enum ClearanceMediaPlatform {
  /** `Meta` */
  Meta = "Meta",
  /** `TikTok` */
  TikTok = "TikTok",
  /** `YouTube` */
  YouTube = "YouTube",
}

export enum ClearanceMediaType {
  Channel = "Channel",
  Video = "Video",
}

export type ClearanceMediaUpdateInput = {
  /** Media ID (channel/video id) */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Media platform */
  platform: ClearanceMediaPlatform;
  /** Media type */
  type?: InputMaybe<ClearanceMediaType>;
  /** Media url */
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClearancePage = {
  __typename?: "ClearancePage";
  /** List of clearances */
  items: Array<Clearance>;
  /** Total number of clearances */
  total: Scalars["Int"]["output"];
};

export type ClearanceSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort Key */
  key?: InputMaybe<ClearanceSortKey>;
};

export enum ClearanceSortKey {
  EndDate = "endDate",
  StartDate = "startDate",
  Status = "status",
}

export type ClearanceSource = {
  __typename?: "ClearanceSource";
  /** Clearance source ID */
  id: Scalars["String"]["output"];
  /** Clearance source type ex. Fawkes */
  type: Scalars["String"]["output"];
};

export enum ClearanceStatus {
  Active = "Active",
  Expired = "Expired",
  Expiring = "Expiring",
  Pending = "Pending",
}

export type ClearanceUpdateInput = {
  /** Clearance end date */
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Clearance ID */
  id: Scalars["ID"]["input"];
  /** Clearance Notes */
  notes?: InputMaybe<Scalars["String"]["input"]>;
  /** Clearance start date */
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type Client = {
  __typename?: "Client";
  /** Client clearances */
  clearances?: Maybe<Array<Maybe<Clearance>>>;
  /** Client contact */
  contact: Scalars["String"]["output"];
  /** Client email */
  email: Scalars["String"]["output"];
  /** Client ID */
  id: Scalars["ID"]["output"];
  /** Client name */
  name: Scalars["String"]["output"];
};

export type ClientPage = {
  __typename?: "ClientPage";
  /** List of clients */
  items: Array<Client>;
  /** Total number of clients */
  total: Scalars["Int"]["output"];
};

export type ClientSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<ClientSortKey>;
};

export enum ClientSortKey {
  Contact = "contact",
  Email = "email",
  Name = "name",
}

export type ClientSource = {
  __typename?: "ClientSource";
  /** Client source ID */
  id: Scalars["String"]["output"];
  /** Client source type ex. Fawkes */
  type: Scalars["String"]["output"];
};

export type Collection = {
  __typename?: "Collection";
  channelIds: Array<Scalars["String"]["output"]>;
  /** Channels belonging to this collection */
  channels: ChannelsPage;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  numberOfChannels: Scalars["Int"]["output"];
};

export type CollectionChannelsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platforms?: InputMaybe<Array<ChannelPlatform>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ChannelsSort>;
};

export type CollectionsPage = {
  __typename?: "CollectionsPage";
  items: Array<Collection>;
  total: Scalars["Int"]["output"];
};

export type CollectionsQueries = {
  __typename?: "CollectionsQueries";
  /** Get the org's collections */
  all?: Maybe<CollectionsPage>;
  /** Get a single collection by id */
  byId?: Maybe<Collection>;
  /** Get one or more collections by id, e.g. to export their channels */
  byIds?: Maybe<Array<Collection>>;
};

export type CollectionsQueriesAllArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platforms?: InputMaybe<Array<ChannelPlatform>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type CollectionsQueriesByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type CollectionsQueriesByIdsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type CommercialLicense = {
  __typename?: "CommercialLicense";
  /** Brand - brand */
  brand: Scalars["String"]["output"];
  /** Campaign name - dealname */
  campaignName: Scalars["String"]["output"];
  /** Close date - closedate */
  closeDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Contacts - UNKNOWN */
  contacts?: Maybe<CommercialLicenseContacts>;
  /** Deal owner - hubspot_owner_id */
  dealOwner?: Maybe<CommercialLicenseContact>;
  /** Documents - p_documents_collection__deal_to_documents */
  documents?: Maybe<Array<CommercialLicenseDocument>>;
  /** Commercial license ID - hs_object_id */
  id: Scalars["ID"]["output"];
  /** Revenue category - revenue_category */
  revenueCategory?: Maybe<Scalars["String"]["output"]>;
  /** Services - p_services_collection__deal_to_services */
  services?: Maybe<Array<CommercialLicenseService>>;
  /** Status - dealstage */
  status: CommercialLicenseStatus;
  /** Terms - p_license_terms_collection__deal_to_license_terms */
  terms?: Maybe<Array<CommercialLicenseTerm>>;
  /** Tracks - line_item_collection__primary */
  tracks?: Maybe<Array<CommercialLicenseTrack>>;
};

export type CommercialLicenseContact = {
  __typename?: "CommercialLicenseContact";
  /** Email - email */
  email: Scalars["String"]["output"];
  /** Name - name */
  name: Scalars["String"]["output"];
};

export type CommercialLicenseContacts = {
  __typename?: "CommercialLicenseContacts";
  additionalContacts?: Maybe<Array<CommercialLicenseContact>>;
  projectLeads?: Maybe<Array<CommercialLicenseContact>>;
};

export type CommercialLicenseDocument = {
  __typename?: "CommercialLicenseDocument";
  /** ID - id */
  id: Scalars["ID"]["output"];
  /** Name - name */
  name: Scalars["String"]["output"];
  /** Type - type */
  type: Scalars["String"]["output"];
  /** Upload date - upload_date */
  uploadDate: Scalars["DateTime"]["output"];
  /** URL - url */
  url: Scalars["String"]["output"];
};

export type CommercialLicensePage = {
  __typename?: "CommercialLicensePage";
  /** List of commercial licenses */
  items: Array<CommercialLicense>;
  /** Total number of commercial licenses */
  total: Scalars["Int"]["output"];
};

export type CommercialLicenseScript = {
  __typename?: "CommercialLicenseScript";
  /** Details - details */
  details: Scalars["Int"]["output"];
  /** Duration - duration */
  duration: Scalars["String"]["output"];
};

export type CommercialLicenseService = {
  __typename?: "CommercialLicenseService";
  /** Cost - cost */
  cost: Scalars["Float"]["output"];
  /** Currency code - currency_code */
  currencyCode: Scalars["String"]["output"];
  /** ID - id */
  id: Scalars["ID"]["output"];
  /** Music type - music_type */
  musicType: Scalars["String"]["output"];
  /** Service type - service_type */
  serviceType: Scalars["String"]["output"];
};

export type CommercialLicenseSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<CommercialLicenseSortKey>;
};

export enum CommercialLicenseSortKey {
  Brand = "brand",
  CampaignName = "campaignName",
  DealOwner = "dealOwner",
}

export enum CommercialLicenseStatus {
  Active = "ACTIVE",
  Expired = "EXPIRED",
  InPerpetuity = "IN_PERPETUITY",
  SoonToExpire = "SOON_TO_EXPIRE",
  Undefined = "UNDEFINED",
}

export type CommercialLicenseTerm = {
  __typename?: "CommercialLicenseTerm";
  /** Duration - duration */
  duration: Scalars["String"]["output"];
  /** End date - end_date */
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Exclusivity - exclusivity */
  exclusivity?: Maybe<Scalars["String"]["output"]>;
  /** Final tracks - final_tracks */
  finalTracks: Array<Scalars["String"]["output"]>;
  /** Media type - media_type */
  mediaType: Scalars["String"]["output"];
  /** Name - name */
  name: Scalars["String"]["output"];
  /** Scripts - scripts */
  scripts: CommercialLicenseScript;
  /** Start date - start_date */
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  status: CommercialLicenseStatus;
  /** Territories - territories */
  territories: CommercialLicenseTerritories;
  /** Time remaining - start_date/end_date */
  timeRemaining: Scalars["String"]["output"];
  /** Time remaining percentage - start_date/end_date */
  timeRemainingPercentage: Scalars["Int"]["output"];
};

export type CommercialLicenseTerritories = {
  __typename?: "CommercialLicenseTerritories";
  excluded: Array<Scalars["String"]["output"]>;
  included: Array<Scalars["String"]["output"]>;
};

export type CommercialLicenseTrack = {
  __typename?: "CommercialLicenseTrack";
  /** Artist - artist */
  artist?: Maybe<Scalars["String"]["output"]>;
  /** Attachments - attachments */
  attachments?: Maybe<Array<CommercialLicenseTrackAttachment>>;
  /** Name - name */
  name?: Maybe<Scalars["String"]["output"]>;
};

export type CommercialLicenseTrackAttachment = {
  __typename?: "CommercialLicenseTrackAttachment";
  /** Name - name */
  name: Scalars["String"]["output"];
  /** URL - url */
  url: Scalars["String"]["output"];
};

export type ConnectChannelInput = {
  channelId: Scalars["String"]["input"];
  channelImage?: InputMaybe<Scalars["String"]["input"]>;
  channelName: Scalars["String"]["input"];
  channelTitle?: InputMaybe<Scalars["String"]["input"]>;
  handle?: InputMaybe<Scalars["String"]["input"]>;
  platform: ChannelPlatform;
  url: Scalars["String"]["input"];
};

/** Creates a draft document. All other fields are populated server-side with sensible defaults (empty content, effective today, no re-agreement, no scroll-to-accept) — the user fills them in on the edit screen. */
export type CreateLegalDocumentInput = {
  key: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type CreateLegalDocumentVariantInput = {
  name: Scalars["String"]["input"];
  orgIds: Array<Scalars["ID"]["input"]>;
  /** Org version to copy (null copies the default version) */
  sourceVariantId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateOrgInput = {
  metadata: CreateOrgMetadataInput;
  name: Scalars["String"]["input"];
  /** Parent Org ID */
  parentOrgId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateOrgMetadataInput = {
  accountManagerEmail: Scalars["String"]["input"];
  accountManagerFirstName: Scalars["String"]["input"];
  accountManagerLastName: Scalars["String"]["input"];
  accountManagerPhone?: InputMaybe<Scalars["String"]["input"]>;
  basicDealId: Scalars["ID"]["input"];
  basicHoldingOrgId?: InputMaybe<Scalars["ID"]["input"]>;
  basicServicingOrgEmail: Scalars["String"]["input"];
  basicServicingOrgId: Scalars["ID"]["input"];
};

export type CreateShareTokenInput = {
  resourceId: Scalars["ID"]["input"];
  resourceType: ShareResourceType;
};

export type CuratedPlaylistCategory = {
  __typename?: "CuratedPlaylistCategory";
  playlistIds: Array<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type CuratedPlaylistQueries = {
  __typename?: "CuratedPlaylistQueries";
  /** List of current user's curated playlists */
  all: Array<Playlist>;
  /** Get a list of curated playlists by category */
  byCategorySlug?: Maybe<PlaylistList>;
  /** List of unique categories in the user's curated playlists */
  categories?: Maybe<Array<CuratedPlaylistCategory>>;
  /** Total count of curated playlists available to the user */
  total: Scalars["Int"]["output"];
};

export type CuratedPlaylistQueriesByCategorySlugArgs = {
  slug: Scalars["String"]["input"];
};

export type Curator = {
  __typename?: "Curator";
  id: Scalars["ID"]["output"];
  imageUrl: Scalars["String"]["output"];
  initials: Scalars["String"]["output"];
  stats: Scalars["String"]["output"];
};

export type CurrentUser = {
  __typename?: "CurrentUser";
  /** User email */
  email: Scalars["String"]["output"];
  /** User first name */
  firstName: Scalars["String"]["output"];
  /** User ID */
  id: Scalars["ID"]["output"];
  /** User orgs */
  inOrgs: Array<UserOrg>;
  /** Impersonation Info */
  isImInfo?: Maybe<IsImInfo>;
  /** Lab App Access */
  labApps?: Maybe<Array<Scalars["String"]["output"]>>;
  /** User last name */
  lastName: Scalars["String"]["output"];
  /** User org ID */
  orgId: Scalars["ID"]["output"];
  /** User permissions (hashed) */
  permissions: Array<Scalars["String"]["output"]>;
  /** User picture */
  picture?: Maybe<Scalars["String"]["output"]>;
  /** The org's subscription, or the plans it can subscribe to, if any billing system reports either */
  subscription?: Maybe<UserSubscription>;
};

export type DeclareTrackChannelInput = {
  /** Channel-specific identifier (e.g. handle or page id) */
  id: Scalars["String"]["input"];
  /** Channel the track is used on */
  type: ChannelPlatform;
  /** Link to the published usage on the channel */
  usageLinks: Array<Scalars["String"]["input"]>;
};

export type DeclareTracksInput = {
  /** Brand or campaign name */
  businessBrand: Scalars["String"]["input"];
  /** Channels the track is used on */
  channels: Array<DeclareTrackChannelInput>;
  /** Date the usage goes live */
  goLiveDate: Scalars["DateTime"]["input"];
  /** Project description */
  projectDescription: Scalars["String"]["input"];
  /** Project or product name */
  projectName: Scalars["String"]["input"];
  /** Regions the track is used in */
  regions: Array<Scalars["String"]["input"]>;
  /** Ids of the tracks being declared */
  trackIds: Array<Scalars["ID"]["input"]>;
};

export enum DefaultViewInDraftMode {
  Development = "DEVELOPMENT",
  Published = "PUBLISHED",
}

export type DistributionQueries = {
  __typename?: "DistributionQueries";
  /** Get The Source portal sign-in URL for the current user */
  signinLink?: Maybe<DistributionSigninLinkResult>;
};

export type DistributionSigninLinkResult = {
  __typename?: "DistributionSigninLinkResult";
  url: Scalars["String"]["output"];
};

export enum DownloadType {
  DownloadMp3 = "download_mp3",
  DownloadWav = "download_wav",
}

export enum DownloadsScope {
  Team = "team",
  User = "user",
}

export type FileValidationResult = {
  __typename?: "FileValidationResult";
  error?: Maybe<Scalars["String"]["output"]>;
  exists: Scalars["Boolean"]["output"];
  filename: Scalars["String"]["output"];
};

export type GeminiModel = {
  __typename?: "GeminiModel";
  /** Human-friendly model name */
  displayName?: Maybe<Scalars["String"]["output"]>;
  /** Model identifier passed to the Gemini API (e.g. gemini-2.0-flash) */
  name: Scalars["String"]["output"];
};

/**
 * Batch lifecycle. Pending is the single working state — what can be done
 * next (generate, pay) is derived from the rows' statuses, not the batch.
 */
export enum ImportBatchStatus {
  Cancelled = "Cancelled",
  Failed = "Failed",
  Generating = "Generating",
  Parsing = "Parsing",
  Pending = "Pending",
}

export enum ImportDataStatus {
  /** Credited to the org's balance, not yet in a payout batch */
  InBalance = "InBalance",
  Matched = "Matched",
  Paid = "Paid",
  PaymentFailed = "PaymentFailed",
  /** In a payout batch Trolley hasn't paid yet */
  PaymentPending = "PaymentPending",
  /** Paid, then returned by Trolley; the amount is back in the balance */
  Returned = "Returned",
  StatementCreated = "StatementCreated",
  Unmatched = "Unmatched",
}

export enum ImportFormat {
  Distribution = "Distribution",
}

export type IngestionJob = {
  __typename?: "IngestionJob";
  catalogUploadId: Scalars["Int"]["output"];
  changeUser?: Maybe<SsoUser>;
  createUser?: Maybe<SsoUser>;
  createdAt?: Maybe<Scalars["String"]["output"]>;
  csvOriginalFilename?: Maybe<Scalars["String"]["output"]>;
  dromoImportId?: Maybe<Scalars["String"]["output"]>;
  dromoImportIdentifier: Scalars["String"]["output"];
  dromoSessionId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  jobName: Scalars["String"]["output"];
  licensorDpid: Scalars["String"]["output"];
  mappingSnapshot?: Maybe<Scalars["JSON"]["output"]>;
  mediaFiles: Array<SavedMediaFile>;
  metadataRowCount?: Maybe<Scalars["Int"]["output"]>;
  orgId: Scalars["String"]["output"];
  orgName?: Maybe<Scalars["String"]["output"]>;
  status: IngestionJobStatus;
  updatedAt: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
};

export type IngestionJobResult = {
  __typename?: "IngestionJobResult";
  id: Scalars["Int"]["output"];
};

export enum IngestionJobStatus {
  AudioUpload = "audio_upload",
  Cancelled = "cancelled",
  CsvMapping = "csv_mapping",
  Done = "done",
  ReadyToIngest = "ready_to_ingest",
  Review = "review",
}

export type IngestionJobsResult = {
  __typename?: "IngestionJobsResult";
  items: Array<IngestionJob>;
  total: Scalars["Int"]["output"];
};

export type IngestionSettingsResult = {
  __typename?: "IngestionSettingsResult";
  dpid: Scalars["String"]["output"];
};

export type IsImInfo = {
  __typename?: "IsImInfo";
  body: Scalars["String"]["output"];
  confirmLabel: Scalars["String"]["output"];
  disclaimer: Scalars["String"]["output"];
  isIm: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

export type LabApp = {
  __typename?: "LabApp";
  /** App Access */
  access: Array<LabAppAccess>;
  /** Allow Fullscreen Mode in App UI */
  allowFullscreen: Scalars["Boolean"]["output"];
  /** Api Key */
  apiKey: Scalars["String"]["output"];
  /** Bridge Key */
  bridgeKey: Scalars["String"]["output"];
  /** Category ID */
  categoryId?: Maybe<Scalars["String"]["output"]>;
  /** Datastore Tables */
  datastoreTables: Array<LabDatastoreTable>;
  /** Default View in Draft Mode */
  defaultViewInDraftMode?: Maybe<DefaultViewInDraftMode>;
  /** App description */
  description: Scalars["String"]["output"];
  /** Display Order in Apps Overview */
  displayOrder?: Maybe<Scalars["Int"]["output"]>;
  /** Environment this app was loaded in */
  env: LabAppEnvironment;
  /** Hide Bottom Bar in App UI */
  hideBottomBar: Scalars["Boolean"]["output"];
  /** App Hosting URL */
  hostingUrl: Scalars["String"]["output"];
  /** App Icon */
  icon?: Maybe<Scalars["String"]["output"]>;
  /** App ID */
  id: Scalars["String"]["output"];
  /** Is Favorited by Current User */
  isFavorited: Scalars["Boolean"]["output"];
  /** App label/name */
  label: Scalars["String"]["output"];
  /** Lab Version */
  labsVersion: LabsVersion;
  /** Last Updated On */
  lastUpdatedOn: Scalars["DateTime"]["output"];
  /** Latest published version of the @songtradr/massivemusic-labs package */
  latestLabsPackageVersion?: Maybe<Scalars["String"]["output"]>;
  /** Legal documents the user must agree to before using the app */
  legalDocuments: Array<LabAppLegalDocument>;
  /** Linked App ID (points to dev app from prod, or prod app from dev) */
  linkedAppId?: Maybe<Scalars["String"]["output"]>;
  /** App Local Development URL */
  localDevelopmentUrl?: Maybe<Scalars["String"]["output"]>;
  /** Modules */
  modules: LabAppModules;
  /** App Parameters */
  parameters: Array<LabAppParameter>;
  /** App Parameters Encoded */
  parametersEncoded?: Maybe<Array<LabAppParameter>>;
  /** Rate Limits */
  rateLimits?: Maybe<RateLimits>;
  /** App Repository Link */
  repositoryLink?: Maybe<Scalars["String"]["output"]>;
  /** Roles assigned to users / orgs for this app */
  roles: Array<LabAppRole>;
  /** App Secrets */
  secrets: Array<LabAppParameter>;
  /** Status */
  status: LabAppStatus;
};

export type LabAppAccess = {
  __typename?: "LabAppAccess";
  /** Access Label */
  label: Scalars["String"]["output"];
  /** Access Value */
  value: Scalars["String"]["output"];
};

export type LabAppAccessInput = {
  /** Access Label */
  label: Scalars["String"]["input"];
  /** Access Value */
  value: Scalars["String"]["input"];
};

export type LabAppDeleteResponse = {
  __typename?: "LabAppDeleteResponse";
  /** Deleted App ID */
  id: Scalars["String"]["output"];
};

export type LabAppDevDifference = {
  __typename?: "LabAppDevDifference";
  /** Development value */
  devValue?: Maybe<Scalars["String"]["output"]>;
  /** Field name */
  field: Scalars["String"]["output"];
  /** Production value */
  prodValue?: Maybe<Scalars["String"]["output"]>;
  /** Detailed record-level changes for datastore tables */
  records?: Maybe<Array<LabAppDevDifferenceRecord>>;
};

export type LabAppDevDifferenceRecord = {
  __typename?: "LabAppDevDifferenceRecord";
  /** Change type: added, modified, deleted */
  changeType: Scalars["String"]["output"];
  /** Development data (JSON) */
  devData?: Maybe<Scalars["String"]["output"]>;
  /** Record ID */
  id: Scalars["String"]["output"];
  /** Production data (JSON) */
  prodData?: Maybe<Scalars["String"]["output"]>;
};

export enum LabAppEnvironment {
  Development = "DEVELOPMENT",
  Production = "PRODUCTION",
}

export type LabAppInput = {
  /** App Access */
  access: Array<LabAppAccessInput>;
  /** Allow Fullscreen Mode in App UI */
  allowFullscreen?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
  /** Datastore Tables */
  datastoreTables?: InputMaybe<Array<LabDatastoreTableInput>>;
  /** Default View in Draft Mode */
  defaultViewInDraftMode?: InputMaybe<DefaultViewInDraftMode>;
  /** App description */
  description: Scalars["String"]["input"];
  /** Display Order in Apps Overview */
  displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
  /** Hide Bottom Bar in App UI */
  hideBottomBar?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** App Hosting URL */
  hostingUrl: Scalars["String"]["input"];
  /** App Icon */
  icon?: InputMaybe<Scalars["String"]["input"]>;
  /** App ID */
  id: Scalars["String"]["input"];
  /** App label */
  label: Scalars["String"]["input"];
  /** Labs Version */
  labsVersion: LabsVersion;
  /** Legal documents the user must agree to */
  legalDocuments?: InputMaybe<Array<LabAppLegalDocumentInput>>;
  /** App Local Development URL */
  localDevelopmentUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Modules */
  modules: LabAppModulesInput;
  /** App Parameters */
  parameters: Array<LabAppParameterInput>;
  /** Rate Limits */
  rateLimits?: InputMaybe<RateLimitsInput>;
  /** App Repository Link */
  repositoryLink?: InputMaybe<Scalars["String"]["input"]>;
  /** Roles assigned to users / orgs (full replace when provided) */
  roles?: InputMaybe<Array<LabAppRoleInput>>;
  /** App Secrets */
  secrets: Array<LabAppParameterInput>;
  /** Status */
  status: LabAppStatus;
};

export type LabAppLegalDocument = {
  __typename?: "LabAppLegalDocument";
  /** Key of a legal document the user must agree to */
  key: Scalars["String"]["output"];
};

export type LabAppLegalDocumentInput = {
  /** Key of a legal document the user must agree to */
  key: Scalars["String"]["input"];
};

export type LabAppModules = {
  __typename?: "LabAppModules";
  /** Datastore Module Enabled */
  dataStore: Scalars["Boolean"]["output"];
  /** Gemini Module Enabled */
  gemini: Scalars["Boolean"]["output"];
  /** Gemini model the app should use (falls back to the service default when unset) */
  geminiModel?: Maybe<Scalars["String"]["output"]>;
  /** Heap analytics tracking module enabled for this Lab app (the host additionally gates the effective value by the org's analytics settings) */
  heapTracking?: Maybe<Scalars["Boolean"]["output"]>;
  /** Music Search Module Enabled */
  musicSearch: Scalars["Boolean"]["output"];
  /** Org Member Search module enabled: the Lab app may list the members of the current user's org via the ORG_MEMBERS host command */
  orgMembers?: Maybe<Scalars["Boolean"]["output"]>;
};

export type LabAppModulesInput = {
  /** Datastore Module Enabled */
  dataStore: Scalars["Boolean"]["input"];
  /** Gemini Module Enabled */
  gemini: Scalars["Boolean"]["input"];
  /** Gemini model the app should use (falls back to the service default when unset) */
  geminiModel?: InputMaybe<Scalars["String"]["input"]>;
  /** Heap analytics tracking module enabled for this Lab app (the host additionally gates the effective value by the org's analytics settings) */
  heapTracking?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Music Search Module Enabled */
  musicSearch: Scalars["Boolean"]["input"];
  /** Org Member Search module enabled: the Lab app may list the members of the current user's org via the ORG_MEMBERS host command */
  orgMembers?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LabAppParameter = {
  __typename?: "LabAppParameter";
  /** Parameter Key */
  key: Scalars["String"]["output"];
  /** Parameter Value */
  value: Scalars["String"]["output"];
};

export type LabAppParameterInput = {
  /** Parameter Key */
  key: Scalars["String"]["input"];
  /** Parameter Value */
  value: Scalars["String"]["input"];
};

export type LabAppRole = {
  __typename?: "LabAppRole";
  /** Members assigned to this role */
  members: Array<LabAppRoleMember>;
  /** Role identifier (lowercase letters and hyphens only) */
  roleId: Scalars["String"]["output"];
};

export type LabAppRoleInput = {
  /** Members assigned to this role */
  members: Array<LabAppRoleMemberInput>;
  /** Role identifier (lowercase letters and hyphens only) */
  roleId: Scalars["String"]["input"];
};

export type LabAppRoleMember = {
  __typename?: "LabAppRoleMember";
  /** Display label resolved from member identifier */
  label: Scalars["String"]["output"];
  /** Member identifier prefixed with USER: or ORG: */
  value: Scalars["String"]["output"];
};

export type LabAppRoleMemberInput = {
  /** Display label resolved from member identifier */
  label: Scalars["String"]["input"];
  /** Member identifier prefixed with USER: or ORG: */
  value: Scalars["String"]["input"];
};

export enum LabAppStatus {
  Draft = "DRAFT",
  Published = "PUBLISHED",
}

export type LabCategory = {
  __typename?: "LabCategory";
  /** Category ID */
  id: Scalars["String"]["output"];
  /** Category Name */
  name: Scalars["String"]["output"];
  /** URL-safe slug derived from name */
  slug: Scalars["String"]["output"];
  /** Sort Order */
  sortOrder: Scalars["Int"]["output"];
};

export type LabCategoryInput = {
  /** Category ID (optional for new categories) */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Category Name */
  name: Scalars["String"]["input"];
  /** Sort Order */
  sortOrder: Scalars["Int"]["input"];
};

export type LabDatastoreAdminCreateInput = {
  /** Data as JSON */
  data: Scalars["JSON"]["input"];
  /** Environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Lab App ID */
  labAppId: Scalars["String"]["input"];
  /** Scope of the record */
  scope: LabDatastoreScope;
  /** Table name */
  tableName: Scalars["String"]["input"];
  /** User ID (required for user-scoped records) */
  userId?: InputMaybe<Scalars["String"]["input"]>;
};

export type LabDatastoreAdminDeleteInput = {
  /** Environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Record IDs */
  ids: Array<Scalars["String"]["input"]>;
  /** Lab App ID */
  labAppId: Scalars["String"]["input"];
  /** Table name */
  tableName: Scalars["String"]["input"];
};

export type LabDatastoreAdminQueryInput = {
  /** Environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Lab App ID */
  labAppId: Scalars["String"]["input"];
  /** Maximum results */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Pagination offset */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Table name in the datastore */
  tableName: Scalars["String"]["input"];
};

export type LabDatastoreAdminRecord = {
  __typename?: "LabDatastoreAdminRecord";
  /** The stored data as JSON */
  data: Scalars["JSON"]["output"];
  /** Record ID */
  id: Scalars["String"]["output"];
  /** Scope of the record */
  scope: LabDatastoreScope;
  /** User ID (for user-scoped records) */
  userId?: Maybe<Scalars["String"]["output"]>;
};

export type LabDatastoreAdminResponse = {
  __typename?: "LabDatastoreAdminResponse";
  /** List of records */
  items: Array<LabDatastoreAdminRecord>;
  /** Total count of records */
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type LabDatastoreAdminUpdateInput = {
  /** Updated data as JSON */
  data: Scalars["JSON"]["input"];
  /** Environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Record ID */
  id: Scalars["String"]["input"];
  /** Lab App ID */
  labAppId: Scalars["String"]["input"];
  /** Table name */
  tableName: Scalars["String"]["input"];
};

export type LabDatastoreFieldDefinition = {
  __typename?: "LabDatastoreFieldDefinition";
  /** Case Insensitive Search */
  caseInsensitive?: Maybe<Scalars["Boolean"]["output"]>;
  /** Field Name */
  name: Scalars["String"]["output"];
  /** Is Field Required */
  required?: Maybe<Scalars["Boolean"]["output"]>;
  /** Is Field Searchable */
  searchable?: Maybe<Scalars["Boolean"]["output"]>;
  /** Field Type */
  type: LabDatastoreFieldType;
};

export type LabDatastoreFieldDefinitionInput = {
  /** Case Insensitive Search */
  caseInsensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Field Name */
  name: Scalars["String"]["input"];
  /** Is Field Required */
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Is Field Searchable */
  searchable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Field Type */
  type: LabDatastoreFieldType;
};

export enum LabDatastoreFieldType {
  Boolean = "BOOLEAN",
  Number = "NUMBER",
  String = "STRING",
}

export enum LabDatastoreScope {
  App = "APP",
  User = "USER",
}

export type LabDatastoreTable = {
  __typename?: "LabDatastoreTable";
  /** Table Field Definitions */
  fields: Array<LabDatastoreFieldDefinition>;
  /** Replace data on merge to production */
  replaceDataOnMerge?: Maybe<Scalars["Boolean"]["output"]>;
  /** Table Scope */
  scope: LabDatastoreScope;
  /** Table Name */
  tableName: Scalars["String"]["output"];
};

export type LabDatastoreTableInput = {
  /** Table Field Definitions */
  fields?: InputMaybe<Array<LabDatastoreFieldDefinitionInput>>;
  /** Replace data on merge to production */
  replaceDataOnMerge?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Table Scope */
  scope: LabDatastoreScope;
  /** Table Name */
  tableName: Scalars["String"]["input"];
};

export type LabsCommandDatastoreFilterInput = {
  /** Field name to filter on */
  field: Scalars["String"]["input"];
  /** Value to match */
  value: Scalars["String"]["input"];
};

export type LabsCommandDatastoreInput = {
  /** Datastore sub-command (save, load, search, delete) */
  action: Scalars["String"]["input"];
  /** JSON data to store (for save action) */
  data?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Search filters (for search action) */
  filters?: InputMaybe<Array<LabsCommandDatastoreFilterInput>>;
  /** Record ID (required for load/delete, optional for save) */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /** Maximum results (for search action) */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Pagination offset (for search action) */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Table name in the datastore */
  tableName: Scalars["String"]["input"];
};

export type LabsCommandDatastoreItem = {
  __typename?: "LabsCommandDatastoreItem";
  /** The stored data as JSON */
  data: Scalars["JSON"]["output"];
  /** Record ID */
  id: Scalars["String"]["output"];
};

export type LabsCommandDatastoreResponse = {
  __typename?: "LabsCommandDatastoreResponse";
  /** The stored data as JSON */
  data?: Maybe<Scalars["JSON"]["output"]>;
  /** Record ID */
  id?: Maybe<Scalars["String"]["output"]>;
  /** List of search results */
  items?: Maybe<Array<LabsCommandDatastoreItem>>;
  /** Whether the operation succeeded */
  success?: Maybe<Scalars["Boolean"]["output"]>;
  /** Total count of matching records */
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type LabsCommandGeminiInput = {
  /** Maximum output tokens */
  maxOutputTokens?: InputMaybe<Scalars["Int"]["input"]>;
  /** Model to use */
  model?: InputMaybe<Scalars["String"]["input"]>;
  /** Prompt to send to Gemini */
  prompt: Scalars["String"]["input"];
  /** System instruction */
  systemInstruction?: InputMaybe<Scalars["String"]["input"]>;
  /** Temperature for response generation */
  temperature?: InputMaybe<Scalars["Float"]["input"]>;
};

export type LabsCommandGeminiResponse = {
  __typename?: "LabsCommandGeminiResponse";
  /** Reason the model stopped generating */
  finishReason?: Maybe<Scalars["String"]["output"]>;
  /** Generated text response */
  text: Scalars["String"]["output"];
};

export type LabsCommandInitResponse = {
  __typename?: "LabsCommandInitResponse";
  /** Authentication token for lab app backend communication */
  authToken: Scalars["String"]["output"];
  /** Role IDs assigned to the current user for this Lab App */
  roles: Array<Scalars["String"]["output"]>;
};

export type LabsCommandInput = {
  /** App ID to execute command against */
  appId: Scalars["String"]["input"];
  /** Command to execute */
  command: Scalars["String"]["input"];
  /** Datastore-specific input */
  datastore?: InputMaybe<LabsCommandDatastoreInput>;
  /** Environment - routes datastore operations to the specified environment */
  env?: InputMaybe<LabAppEnvironment>;
  /** Gemini-specific input */
  gemini?: InputMaybe<LabsCommandGeminiInput>;
  /** Log Error-specific input */
  logError?: InputMaybe<LabsCommandLogErrorInput>;
  /** Music Search-specific input */
  musicSearch?: InputMaybe<LabsCommandMusicSearchInput>;
  /** Org Members-specific input */
  orgMembers?: InputMaybe<LabsCommandOrgMembersInput>;
  /** User Action Log-specific input */
  userActionLog?: InputMaybe<LabsCommandUserActionLogInput>;
};

export type LabsCommandLogErrorInput = {
  /** Error message */
  message: Scalars["String"]["input"];
  /** Error stack trace */
  stack?: InputMaybe<Scalars["String"]["input"]>;
};

export type LabsCommandLogErrorResponse = {
  __typename?: "LabsCommandLogErrorResponse";
  /** Whether the error was logged successfully */
  success: Scalars["Boolean"]["output"];
};

export type LabsCommandMusicSearchInput = {
  /** Number of results to return */
  limit: Scalars["Int"]["input"];
  /** Number of results to skip for pagination */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Search query */
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** Search type (e.g., SMART_SEARCH, EXACT_MATCH) */
  searchType?: InputMaybe<SearchType>;
};

export type LabsCommandMusicSearchResponse = {
  __typename?: "LabsCommandMusicSearchResponse";
  /** Total number of tracks matching the search criteria */
  total: Scalars["Int"]["output"];
  /** List of tracks matching the search criteria */
  tracks: Array<Track>;
};

export type LabsCommandOrgMember = {
  __typename?: "LabsCommandOrgMember";
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  /** User ID, matches the userId in the Lab auth token */
  userId: Scalars["ID"]["output"];
};

export type LabsCommandOrgMembersInput = {
  /** Number of members to return (max 100) */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Number of members to skip for pagination */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Filters members by name or email */
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type LabsCommandOrgMembersResponse = {
  __typename?: "LabsCommandOrgMembersResponse";
  /** Whether this is the last page */
  isLastPage: Scalars["Boolean"]["output"];
  /** Active members of the current user's org */
  members: Array<LabsCommandOrgMember>;
  /** Total number of matching members */
  total: Scalars["Int"]["output"];
};

export type LabsCommandResult =
  | LabsCommandDatastoreResponse
  | LabsCommandGeminiResponse
  | LabsCommandInitResponse
  | LabsCommandLogErrorResponse
  | LabsCommandMusicSearchResponse
  | LabsCommandOrgMembersResponse
  | LabsCommandUserActionLogResponse;

export type LabsCommandUserActionLogInput = {
  /** Action identifier (e.g. INIT, BUTTON_CLICK, etc.) */
  action: Scalars["String"]["input"];
  /** Optional arbitrary data */
  data?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Path / route within the lab app */
  path?: InputMaybe<Scalars["String"]["input"]>;
  /** Reference identifier */
  reference: Scalars["String"]["input"];
  /** Reference key */
  referenceKey: Scalars["String"]["input"];
};

export type LabsCommandUserActionLogResponse = {
  __typename?: "LabsCommandUserActionLogResponse";
  /** Whether the action was logged successfully */
  success: Scalars["Boolean"]["output"];
};

export enum LabsVersion {
  V1 = "V1",
}

/** A user's acceptance of a legal document version */
export type LegalAgreementListItem = {
  __typename?: "LegalAgreementListItem";
  agreedAt: Scalars["DateTime"]["output"];
  /** Name of the accepted document version */
  documentName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** Key of the accepted document */
  key: Scalars["String"]["output"];
  /** Org the user accepted for (null on acceptances recorded before org versions) */
  orgId?: Maybe<Scalars["ID"]["output"]>;
  orgName?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<SsoUser>;
  /** Label of the accepted org version (null for the default version) */
  variantName?: Maybe<Scalars["String"]["output"]>;
  /** Accepted document version */
  version: Scalars["Int"]["output"];
};

export type LegalAgreementPage = {
  __typename?: "LegalAgreementPage";
  items: Array<LegalAgreementListItem>;
  total: Scalars["Int"]["output"];
};

export type LegalAgreementRecord = {
  __typename?: "LegalAgreementRecord";
  agreedAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  key: Scalars["String"]["output"];
  version: Scalars["Int"]["output"];
};

export type LegalConfirmation = {
  __typename?: "LegalConfirmation";
  /** User-facing confirmation text the user must agree to */
  label: Scalars["String"]["output"];
};

export type LegalConfirmationInput = {
  label: Scalars["String"]["input"];
};

export type LegalDocument = {
  __typename?: "LegalDocument";
  /** Whether this version is the currently-active one for its key */
  active: Scalars["Boolean"]["output"];
  /** Names of the active org versions of this document (null on org versions) */
  activeOrgVersionNames?: Maybe<Array<Scalars["String"]["output"]>>;
  changeDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User who last modified this version (falls back to createdByUser) */
  changedByUser?: Maybe<SsoUser>;
  /** Confirmation statements the user must agree to alongside the document */
  confirmations: Array<LegalConfirmation>;
  /** Document content as a JSON-serialized Tiptap document (stringified to avoid tripping WAF XSS rules on raw HTML) */
  content: Scalars["String"]["output"];
  createDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User who created this version */
  createdByUser?: Maybe<SsoUser>;
  /** Date the document takes effect */
  effectiveDate: Scalars["DateTime"]["output"];
  /** Whether users on this version are asked to accept it (false while an admin has switched it off) */
  enabled: Scalars["Boolean"]["output"];
  /** Legal document ID (unique per version) */
  id: Scalars["ID"]["output"];
  /** URL-safe key (lowercase a-z, 0-9, hyphen). Stable across versions. */
  key: Scalars["String"]["output"];
  /** Display name */
  name: Scalars["String"]["output"];
  /** ID of the version this one replaced (null on the first version) */
  previousVersionId?: Maybe<Scalars["ID"]["output"]>;
  /** Whether users must re-agree when the document changes */
  requiresReagreement: Scalars["Boolean"]["output"];
  /** Whether users must scroll to the end of the document before they can accept */
  requiresScrollToAccept: Scalars["Boolean"]["output"];
  /** Org version this row belongs to (null for the default version) */
  variantId?: Maybe<Scalars["ID"]["output"]>;
  /** Label of the org version (null for the default version) */
  variantName?: Maybe<Scalars["String"]["output"]>;
  /** Document version — incremented automatically on every save */
  version: Scalars["Int"]["output"];
};

/** An entry in the legal document change log, sourced from the user action log */
export type LegalDocumentChangeLogEntry = {
  __typename?: "LegalDocumentChangeLogEntry";
  /** When the change was made (ISO timestamp) */
  createdAt: Scalars["DateTime"]["output"];
  /** User action log entry ID */
  id: Scalars["ID"]["output"];
  /** Key of the legal document this entry belongs to */
  key: Scalars["String"]["output"];
  /** Human-readable list of changes made in this entry */
  summary: Array<Scalars["String"]["output"]>;
  /** The user who made the change */
  user?: Maybe<SsoUser>;
  /** Org version the change was made to (null for the default version) */
  variantId?: Maybe<Scalars["ID"]["output"]>;
  /** Label of that org version */
  variantName?: Maybe<Scalars["String"]["output"]>;
  /** Version of the legal document this entry produced (1 for the create) */
  version: Scalars["Int"]["output"];
};

export type LegalDocumentChangeLogPage = {
  __typename?: "LegalDocumentChangeLogPage";
  items: Array<LegalDocumentChangeLogEntry>;
  total: Scalars["Int"]["output"];
};

/** An org assigned to an org version, or excluded from or included in a legal document */
export type LegalDocumentOrg = {
  __typename?: "LegalDocumentOrg";
  orgId: Scalars["ID"]["output"];
  orgName?: Maybe<Scalars["String"]["output"]>;
};

/** How a legal document applies to orgs: the default version, org versions and the excluded or included orgs */
export type LegalDocumentOrgVersions = {
  __typename?: "LegalDocumentOrgVersions";
  /** Active default version, shown to every asked org without an org version */
  defaultDocument?: Maybe<LegalDocument>;
  /** Orgs that are never asked to accept the document (e.g. they agreed by contract) */
  excludedOrgs: Array<LegalDocumentOrg>;
  /** Orgs asked to accept the default version when onlyIncludedOrgs is set */
  includedOrgs: Array<LegalDocumentOrg>;
  /** Whether only included orgs and orgs on an org version are asked, instead of every org that isn't excluded */
  onlyIncludedOrgs: Scalars["Boolean"]["output"];
  variants: Array<LegalDocumentVariant>;
};

export type LegalDocumentPage = {
  __typename?: "LegalDocumentPage";
  /** List of legal documents */
  items: Array<LegalDocument>;
  /** Total number of legal documents */
  total: Scalars["Int"]["output"];
};

/** An alternative version of a legal document shown to its orgs instead of the default */
export type LegalDocumentVariant = {
  __typename?: "LegalDocumentVariant";
  /** Active document row of this version */
  document?: Maybe<LegalDocument>;
  id: Scalars["ID"]["output"];
  /** Key of the legal document */
  key: Scalars["String"]["output"];
  /** Admin-facing label */
  name: Scalars["String"]["output"];
  /** Orgs that see this version */
  orgs: Array<LegalDocumentOrg>;
};

export type LibraryLicense = {
  __typename?: "LibraryLicense";
  businessBrand?: Maybe<Scalars["String"]["output"]>;
  channels: Array<LibraryLicenseDeclaredUsageChannel>;
  declaredByUser: LibraryLicenseUser;
  declaredDate: Scalars["DateTime"]["output"];
  downloadLink?: Maybe<Scalars["String"]["output"]>;
  downloadedByUser: LibraryLicenseUser;
  goLiveDate: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  orgId: Scalars["ID"]["output"];
  orgName?: Maybe<Scalars["String"]["output"]>;
  projectDescription?: Maybe<Scalars["String"]["output"]>;
  projectName: Scalars["String"]["output"];
  regions: Array<Scalars["String"]["output"]>;
  trackArtist: Scalars["String"]["output"];
  trackId: Scalars["ID"]["output"];
  trackTitle: Scalars["String"]["output"];
};

export enum LibraryLicenseChannelType {
  CompanyWebsite = "CompanyWebsite",
  Facebook = "Facebook",
  Instagram = "Instagram",
  LinkedIn = "LinkedIn",
  Other = "Other",
  TikTok = "TikTok",
  Twitter = "Twitter",
  Youtube = "Youtube",
}

export type LibraryLicenseDeclaredUsageChannel = {
  __typename?: "LibraryLicenseDeclaredUsageChannel";
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  type: LibraryLicenseChannelType;
  url?: Maybe<Scalars["String"]["output"]>;
  usageLinks?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type LibraryLicenseSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<LibraryLicenseSortKey>;
};

export enum LibraryLicenseSortKey {
  DeclaredByUser = "declaredByUser",
  GoLiveDate = "goLiveDate",
  OrgName = "orgName",
  ProjectDescription = "projectDescription",
  ProjectName = "projectName",
  TrackArtist = "trackArtist",
  TrackTitle = "trackTitle",
}

export type LibraryLicenseUser = {
  __typename?: "LibraryLicenseUser";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type LibraryLicensesSummary = {
  __typename?: "LibraryLicensesSummary";
  /** Total number of library licenses based on filters */
  total: Scalars["Int"]["output"];
  /** Years for which queried library licenses are available */
  years: Array<Scalars["Int"]["output"]>;
};

export enum LikeItemsType {
  Playlist = "playlist",
  Stem = "stem",
  Track = "track",
}

export type MsaDocument = {
  __typename?: "MsaDocument";
  id: Scalars["String"]["output"];
  selection: MsaDocumentSelection;
  signatoryId: Scalars["String"]["output"];
};

export type MsaDocumentCreateInput = {
  key: Scalars["String"]["input"];
  selection: MsaDocumentSelection;
};

export type MsaDocumentCreateResponse = {
  __typename?: "MsaDocumentCreateResponse";
  url: Scalars["String"]["output"];
};

export type MsaDocumentGetResponse = {
  __typename?: "MsaDocumentGetResponse";
  url: Scalars["String"]["output"];
};

export enum MsaDocumentSelection {
  OneOff = "OneOff",
  OneOffWithStudioAndDrm = "OneOffWithStudioAndDrm",
}

export type MsaFieldChange = {
  __typename?: "MsaFieldChange";
  field: Scalars["String"]["output"];
  newValue: Scalars["String"]["output"];
  oldValue: Scalars["String"]["output"];
};

export type MsaLogEntry = {
  __typename?: "MsaLogEntry";
  action: Action;
  actionDescription: Scalars["String"]["output"];
  fieldChange?: Maybe<MsaFieldChange>;
  key: Scalars["String"]["output"];
  surveyResponse?: Maybe<MsaSurveyResponse>;
};

export type MsaLogEntryInput = {
  action: Action;
  key: Scalars["String"]["input"];
};

export enum MsaMonetizationPreference {
  Claim = "claim",
  Protect = "protect",
}

export type MsaProfile = {
  __typename?: "MsaProfile";
  companyName?: Maybe<Scalars["String"]["output"]>;
  documentSelection: MsaDocumentSelection;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  monetizationPreference: MsaMonetizationPreference;
  msaDocument?: Maybe<MsaDocument>;
  source: MsaProfileSource;
  status: MsaProfileStatus;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type MsaProfileCreateInput = {
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  source: MsaProfileSourceInput;
};

export type MsaProfileDocumentSelectionUpdateInput = {
  key: Scalars["String"]["input"];
  selection: MsaDocumentSelection;
};

export type MsaProfileMonetizationPrefUpdateInput = {
  key: Scalars["String"]["input"];
  preference: MsaMonetizationPreference;
};

export type MsaProfileSource = {
  __typename?: "MsaProfileSource";
  /** Source ID - ex. A MarketplaceId used to transfer songs to Phoenix - Requiring all sources provide unique IDs for each Msa Profile to be created. */
  id: Scalars["Int"]["output"];
  /** Source Type - ex. Marketplace */
  type: MsaSourceType;
};

export type MsaProfileSourceInput = {
  id: Scalars["Int"]["input"];
  type: MsaSourceType;
};

export enum MsaProfileStatus {
  Created = "Created",
  Declined = "Declined",
  Signed = "Signed",
  Viewed = "Viewed",
}

export type MsaProfileStatusUpdateInput = {
  key: Scalars["String"]["input"];
  status: MsaProfileStatus;
};

export enum MsaSourceType {
  Marketplace = "Marketplace",
  Tests = "Tests",
}

export type MsaSurveyData = {
  __typename?: "MsaSurveyData";
  selectionBitMask: Scalars["Int"]["output"];
  textResponse?: Maybe<Scalars["String"]["output"]>;
};

export type MsaSurveyLogEntryInput = {
  key: Scalars["String"]["input"];
  selectionBitMask: Scalars["Int"]["input"];
  textResponse?: InputMaybe<Scalars["String"]["input"]>;
};

export type MsaSurveyResponse = {
  __typename?: "MsaSurveyResponse";
  selectionDescriptions?: Maybe<Array<Scalars["String"]["output"]>>;
  selectionKeys: Array<Scalars["String"]["output"]>;
  textResponse?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  /** Accept user invite to org */
  acceptUserInviteToOrg: OrgUser;
  /** Add the channels to the given collections */
  addChannelsToCollections: Array<Collection>;
  /** This operation allows to create a new client. */
  addClient?: Maybe<Client>;
  /** Add a lab app to favorites */
  addLabAppFavorite: Scalars["Boolean"]["output"];
  addLikes: Scalars["Boolean"]["output"];
  addMsaLogEntry: MsaLogEntry;
  addMsaSurveyLogEntry: MsaLogEntry;
  /** Reply in an org's payout conversation */
  addPayoutComment: PayoutComment;
  addTracksToPlaylists: Scalars["Boolean"]["output"];
  /** Start a bulk-download job for the referenced resources and return the job */
  bulkDownload: BulkDownload;
  /** Cancel an ingestion job */
  cancelIngestionJob: IngestionJob;
  clearUnreadNotifications: Scalars["Boolean"]["output"];
  /** Connect one or more resolved social channels to the current user's account, and add them to the given collections */
  connectChannels: Array<Channel>;
  /** This operation allows to create a new app */
  createApp: LabApp;
  /** This operation allows to create a new clearance. It gets the input and communicates with Aegis to create a new clearance. */
  createClearance?: Maybe<Clearance>;
  /** Create a collection for the current org, holding the given channels */
  createCollection: Collection;
  /** Create a new datastore record as admin */
  createDatastoreAdminRecord: LabDatastoreAdminRecord;
  /** Create a new ingestion job */
  createIngestionJob: IngestionJob;
  /** Create a new legal document */
  createLegalDocument: LegalDocument;
  /** Create an org version as a copy of the default or another org version. An org can have only one version and cannot be excluded. */
  createLegalDocumentVariant: LegalDocumentVariant;
  createMsaDocument: MsaDocumentCreateResponse;
  createMsaProfile: MsaProfile;
  /** Create organization */
  createOrg: Org;
  /** Get a signed S3 URL for org asset upload */
  createOrgAssetSignedUploadUrl: OrgAssetSignedUploadUrl;
  /** Start creating an open Trolley batch for the given orgs; it is prepared in the background and records its progress. Processing is started in Trolley */
  createPayoutBatch: PayoutBatch;
  /** Create a share token granting public read access to a resource */
  createShareToken: Scalars["String"]["output"];
  createSignatureDocument: SignatureDocumentCreateResponse;
  createSignatureDocumentTemplate: SignatureDocumentTemplate;
  /** This operation allows to create a new statement */
  createStatement?: Maybe<Statement>;
  /** Create stem separation task and return one Stem record per target */
  createStems: Stem;
  /** Deactivate one or more of the org's connected channels */
  deactivateChannels: Array<Channel>;
  /** Deactivate user in org */
  deactivateUserInOrg: OrgUser;
  /** Declare a licensed usage for a downloaded track */
  declareTracks: Scalars["Boolean"]["output"];
  declineSignatureDocument: SignatureDocument;
  /** Delete all recent searches for the user */
  deleteAllRecentSearches: Scalars["Boolean"]["output"];
  /** This operation allows to delete an existing app */
  deleteApp: LabAppDeleteResponse;
  /** Delete one or more of the org's collections. The channels inside are untouched. */
  deleteCollections: Array<Scalars["ID"]["output"]>;
  /** Delete a datastore record as admin */
  deleteDatastoreAdminRecords: LabsCommandDatastoreResponse;
  /** Delete (soft) an ingestion job */
  deleteIngestionJob: Scalars["Boolean"]["output"];
  /** Delete a media file from an ingestion job (removes from S3 and updates the job) */
  deleteIngestionJobMediaFile: IngestionJob;
  /** Remove a lab app from favorites */
  deleteLabAppFavorite: Scalars["Boolean"]["output"];
  /** Soft-delete a legal document by key (removes every version, org versions and org assignments) */
  deleteLegalDocument: Scalars["Boolean"]["output"];
  /** Delete an org version; its orgs get the default version again */
  deleteLegalDocumentVariant: Scalars["Boolean"]["output"];
  deleteLikes: Scalars["Boolean"]["output"];
  /** Start deleting, in the background, a Creating, Open or NeedsReview batch Trolley can't pay: open in Trolley (deleted there too), gone from Trolley, processed with no unpaid payout Trolley may still pay, never sent, or unconfirmed and not found in Trolley. Its unpaid items, including those of failed payments, return to the balance */
  deletePayoutBatch: PayoutBatch;
  deletePlaylist: Scalars["Boolean"]["output"];
  /** Delete a specific recent search by its log entry ID */
  deleteRecentSearch: Scalars["Boolean"]["output"];
  /** Duplicate a collection, copying its name and channels */
  duplicateCollection: Collection;
  emitMsaProfileToMusicBus: MsaProfile;
  /** Execute a catalog upload */
  executeCatalogUpload: IngestionJobResult;
  /** This operation allows to expire a specific clearance by provided `clearanceId`. It gets the clearance and communicates with Aegis to update its status to `Expired`. */
  expireClearance?: Maybe<Clearance>;
  /** Queue invites for every address that can receive one; sending happens in the background */
  inviteUserToOrg: OrgUserInviteBatch;
  markNotificationAsRead: Scalars["Boolean"]["output"];
  /** Mark an unpaid payout Paid once Trolley shows it was paid outside this batch: a processed payment to the same recipient for the exact amount, made since the batch was created and not linked to another payout. Then updates the batch status, or refreshes it in the background while another task runs */
  markPayoutPaid: PayoutBatch;
  /** Merge dev app config into production */
  mergeDevToProduction: LabApp;
  /** Reactivate one or more of the org's deactivated channels */
  reactivateChannels: Array<Channel>;
  /** Reactivate user in org */
  reactivateUserInOrg: OrgUser;
  /** Record that the current user has accepted a specific version of a legal document. */
  recordLegalAgreement: LegalAgreementRecord;
  /** Release payouts Trolley won't pay in this batch, returning their items to the balance, after checking only them in Trolley: failed ones whose payment is still failed stop being held, and Open ones whose org has no payment in the processed Trolley batch (e.g. removed by Finance) nor one that may be it re-sent are cancelled. Then updates the batch status. While another task runs, or before a complete refresh, a background refresh carries out the request instead */
  releasePayouts: PayoutBatch;
  /** Remove the channels from the given collections */
  removeChannelsFromCollections: Array<Collection>;
  /** Remove org user invite */
  removeOrgUserInvite: Scalars["Boolean"]["output"];
  removeTracksFromPlaylists: Scalars["Boolean"]["output"];
  /** Remove user from org */
  removeUserFromOrg: OrgUser;
  /** Rename a collection */
  renameCollection: Collection;
  reorderPlaylistTracks: Playlist;
  /** Resend org user invite; an expired invite is sent again as pending */
  resendOrgUserInvite: Scalars["Boolean"]["output"];
  /** Revert a single dev field to its production value */
  revertDevField: Scalars["Boolean"]["output"];
  /** Put an org on hold, so it is never batched, or release it; the comment says why */
  setPayoutHold: PayoutComment;
  signSignatureDocument: SignatureDocument;
  /** Start a new music ingestion job and get upload URL */
  startIngestionJob: IngestionJobResult;
  /** Cancel a batch that has not generated statements yet */
  statementImportCancelBatch: StatementImportBatch;
  /** Create a batch from an uploaded royalty file: parse, match and prepare for review */
  statementImportCreateBatch: StatementImportBatch;
  /** Delete a cancelled batch */
  statementImportDeleteBatch: Scalars["Boolean"]["output"];
  /** Generate unpaid statements for all included, matched rows */
  statementImportGenerateStatements: StatementImportBatch;
  /** Trigger payment for included rows with statements (all, or a subset by id) */
  statementImportPay: StatementImportBatch;
  /** Include or exclude all rows, optionally narrowed to one status */
  statementImportSetAllIncluded: Scalars["Int"]["output"];
  /** Include or exclude specific rows */
  statementImportSetIncluded: Scalars["Int"]["output"];
  /** Submit a customer support inquiry */
  submitInquiry: Scalars["Boolean"]["output"];
  /** Start updating a batch and its payouts from Trolley in the background; the batch shows the progress. Does nothing while a task runs */
  syncPayoutBatch: PayoutBatch;
  /** Start refreshing every Trolley recipient's status in the background; false when a refresh is already running */
  syncPayoutRecipients: Scalars["Boolean"]["output"];
  /** This operation allows to update an existing app */
  updateApp: LabApp;
  /** This operation allows to update a specific clearance by provided `clearanceId`. It gets the clearance and communicates with Aegis to update its `startDate`, `endDate` and `notes`. It returns the updated clearance with the new `startDate`, `endDate` and `notes`. At the moment of writing it is not possible to update other fields. */
  updateClearance?: Maybe<Clearance>;
  /** This operation allows to update a client. */
  updateClient?: Maybe<Client>;
  /** Update a datastore record as admin */
  updateDatastoreAdminRecord: LabDatastoreAdminRecord;
  /** Update an existing ingestion job */
  updateIngestionJob: IngestionJob;
  /** Update ingestion settings for the current org */
  updateIngestionSettings: IngestionSettingsResult;
  /** Update Lab Categories (full replace) */
  updateLabCategories: Array<LabCategory>;
  /** Update an existing legal document by key — its org version variantId, or the default version */
  updateLegalDocument: LegalDocument;
  /** Set whether a legal document asks every org except the excluded ones or only the included ones, and replace that list. Switching clears the other list. Orgs with an org version cannot be listed. */
  updateLegalDocumentOrgList: Array<LegalDocumentOrg>;
  /** Rename an org version and replace its orgs */
  updateLegalDocumentVariant: LegalDocumentVariant;
  updateMsaProfileDocumentSelection: MsaProfile;
  updateMsaProfileMonetizationPref: MsaProfile;
  updateMsaProfileStatus: MsaProfile;
  /** Update org branding assets */
  updateOrgAssets: Scalars["Boolean"]["output"];
  /** Update organization details */
  updateOrgDetails: Scalars["Boolean"]["output"];
  /** Update organization modules */
  updateOrgModules: Scalars["Boolean"]["output"];
  /** Update org user roles and permissions */
  updateOrgUserInvite: OrgUserInvite;
  /** Set the current org's payout minimum (USD cents, at least ) */
  updatePayoutMinimum: PayoutBalance;
  updateSignatory: SignatureDocumentSignatoryUpdateResponse;
  /** This operation allows to update an existing statement */
  updateStatement?: Maybe<Statement>;
  /** Update org user roles and permissions */
  updateUserPermissionsInOrg: OrgUser;
  upsertPlaylist: Playlist;
  /** Validate if files exist in S3 bucket */
  validateFilesInS3: Array<FileValidationResult>;
};

export type MutationAcceptUserInviteToOrgArgs = {
  inviteId: Scalars["ID"]["input"];
};

export type MutationAddChannelsToCollectionsArgs = {
  channelIds: Array<Scalars["ID"]["input"]>;
  collectionIds: Array<Scalars["ID"]["input"]>;
};

export type MutationAddClientArgs = {
  input: AddClientInput;
};

export type MutationAddLabAppFavoriteArgs = {
  labAppId: Scalars["String"]["input"];
};

export type MutationAddLikesArgs = {
  itemIds: Array<Scalars["ID"]["input"]>;
  itemType: LikeItemsType;
};

export type MutationAddMsaLogEntryArgs = {
  input: MsaLogEntryInput;
};

export type MutationAddMsaSurveyLogEntryArgs = {
  input: MsaSurveyLogEntryInput;
};

export type MutationAddPayoutCommentArgs = {
  body: Scalars["String"]["input"];
  orgId: Scalars["String"]["input"];
};

export type MutationAddTracksToPlaylistsArgs = {
  playlistIds: Array<Scalars["ID"]["input"]>;
  trackIds: Array<Scalars["ID"]["input"]>;
};

export type MutationBulkDownloadArgs = {
  referenceFormat: BulkDownloadReferenceFormat;
  referenceIds: Array<Scalars["ID"]["input"]>;
  referenceType: BulkDownloadReferenceType;
  source?: InputMaybe<UserActionLogSource>;
  sourceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCancelIngestionJobArgs = {
  jobId: Scalars["ID"]["input"];
};

export type MutationConnectChannelsArgs = {
  collectionIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  input: Array<ConnectChannelInput>;
};

export type MutationCreateAppArgs = {
  label: Scalars["String"]["input"];
};

export type MutationCreateClearanceArgs = {
  input: ClearanceCreateInput;
};

export type MutationCreateCollectionArgs = {
  channelIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  name: Scalars["String"]["input"];
};

export type MutationCreateDatastoreAdminRecordArgs = {
  input: LabDatastoreAdminCreateInput;
};

export type MutationCreateIngestionJobArgs = {
  jobName: Scalars["String"]["input"];
  licensorDpid: Scalars["String"]["input"];
};

export type MutationCreateLegalDocumentArgs = {
  input: CreateLegalDocumentInput;
};

export type MutationCreateLegalDocumentVariantArgs = {
  input: CreateLegalDocumentVariantInput;
  key: Scalars["String"]["input"];
};

export type MutationCreateMsaDocumentArgs = {
  input: MsaDocumentCreateInput;
};

export type MutationCreateMsaProfileArgs = {
  input: MsaProfileCreateInput;
};

export type MutationCreateOrgArgs = {
  input: CreateOrgInput;
};

export type MutationCreateOrgAssetSignedUploadUrlArgs = {
  contentType: Scalars["String"]["input"];
  hash: Scalars["String"]["input"];
};

export type MutationCreatePayoutBatchArgs = {
  orgIds: Array<Scalars["String"]["input"]>;
};

export type MutationCreateShareTokenArgs = {
  input: CreateShareTokenInput;
};

export type MutationCreateSignatureDocumentArgs = {
  input: SignatureDocumentCreateInput;
};

export type MutationCreateSignatureDocumentTemplateArgs = {
  input: SignatureDocumentTemplateCreateInput;
};

export type MutationCreateStatementArgs = {
  input: StatementCreateInput;
};

export type MutationCreateStemsArgs = {
  modelId: Scalars["String"]["input"];
  trackId: Scalars["ID"]["input"];
};

export type MutationDeactivateChannelsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationDeactivateUserInOrgArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeclareTracksArgs = {
  input: DeclareTracksInput;
};

export type MutationDeclineSignatureDocumentArgs = {
  input: SignatureDocumentDeclineInput;
};

export type MutationDeleteAppArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteCollectionsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationDeleteDatastoreAdminRecordsArgs = {
  input: LabDatastoreAdminDeleteInput;
};

export type MutationDeleteIngestionJobArgs = {
  jobId: Scalars["ID"]["input"];
};

export type MutationDeleteIngestionJobMediaFileArgs = {
  jobId: Scalars["ID"]["input"];
  mediaFileId: Scalars["String"]["input"];
};

export type MutationDeleteLabAppFavoriteArgs = {
  labAppId: Scalars["String"]["input"];
};

export type MutationDeleteLegalDocumentArgs = {
  key: Scalars["String"]["input"];
};

export type MutationDeleteLegalDocumentVariantArgs = {
  id: Scalars["ID"]["input"];
  key: Scalars["String"]["input"];
};

export type MutationDeleteLikesArgs = {
  itemIds: Array<Scalars["ID"]["input"]>;
  itemType: LikeItemsType;
};

export type MutationDeletePayoutBatchArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeletePlaylistArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteRecentSearchArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDuplicateCollectionArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationEmitMsaProfileToMusicBusArgs = {
  key: Scalars["String"]["input"];
};

export type MutationExecuteCatalogUploadArgs = {
  dromoUploadId: Scalars["String"]["input"];
  id: Scalars["Int"]["input"];
};

export type MutationExpireClearanceArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationInviteUserToOrgArgs = {
  accessEndDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  invites: Array<OrgUserInviteInput>;
};

export type MutationMarkNotificationAsReadArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationMarkPayoutPaidArgs = {
  id: Scalars["String"]["input"];
  payoutId: Scalars["String"]["input"];
};

export type MutationMergeDevToProductionArgs = {
  id: Scalars["String"]["input"];
};

export type MutationReactivateChannelsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationReactivateUserInOrgArgs = {
  accessEndDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type MutationRecordLegalAgreementArgs = {
  input: RecordLegalAgreementInput;
};

export type MutationReleasePayoutsArgs = {
  id: Scalars["String"]["input"];
  payoutIds: Array<Scalars["String"]["input"]>;
};

export type MutationRemoveChannelsFromCollectionsArgs = {
  channelIds: Array<Scalars["ID"]["input"]>;
  collectionIds: Array<Scalars["ID"]["input"]>;
};

export type MutationRemoveOrgUserInviteArgs = {
  inviteId: Scalars["ID"]["input"];
};

export type MutationRemoveTracksFromPlaylistsArgs = {
  playlistIds: Array<Scalars["ID"]["input"]>;
  trackIds: Array<Scalars["ID"]["input"]>;
};

export type MutationRemoveUserFromOrgArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationRenameCollectionArgs = {
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
};

export type MutationReorderPlaylistTracksArgs = {
  id: Scalars["ID"]["input"];
  trackIds: Array<Scalars["ID"]["input"]>;
};

export type MutationResendOrgUserInviteArgs = {
  accessEndDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  inviteId: Scalars["ID"]["input"];
};

export type MutationRevertDevFieldArgs = {
  field: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationSetPayoutHoldArgs = {
  comment: Scalars["String"]["input"];
  onHold: Scalars["Boolean"]["input"];
  orgId: Scalars["String"]["input"];
};

export type MutationSignSignatureDocumentArgs = {
  input: SignatureDocumentSignInput;
};

export type MutationStartIngestionJobArgs = {
  jobName: Scalars["String"]["input"];
  licensorDpid: Scalars["String"]["input"];
};

export type MutationStatementImportCancelBatchArgs = {
  batchId: Scalars["String"]["input"];
};

export type MutationStatementImportCreateBatchArgs = {
  input: StatementImportCreateBatchInput;
};

export type MutationStatementImportDeleteBatchArgs = {
  batchId: Scalars["String"]["input"];
};

export type MutationStatementImportGenerateStatementsArgs = {
  batchId: Scalars["String"]["input"];
};

export type MutationStatementImportPayArgs = {
  batchId: Scalars["String"]["input"];
  dataIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationStatementImportSetAllIncludedArgs = {
  batchId: Scalars["String"]["input"];
  included: Scalars["Boolean"]["input"];
  status?: InputMaybe<ImportDataStatus>;
};

export type MutationStatementImportSetIncludedArgs = {
  batchId: Scalars["String"]["input"];
  dataIds: Array<Scalars["String"]["input"]>;
  included: Scalars["Boolean"]["input"];
};

export type MutationSubmitInquiryArgs = {
  category: Scalars["String"]["input"];
  inquiry: Scalars["String"]["input"];
};

export type MutationSyncPayoutBatchArgs = {
  id: Scalars["String"]["input"];
};

export type MutationUpdateAppArgs = {
  env?: InputMaybe<LabAppEnvironment>;
  input: LabAppInput;
};

export type MutationUpdateClearanceArgs = {
  input: ClearanceUpdateInput;
};

export type MutationUpdateClientArgs = {
  input: UpdateClientInput;
};

export type MutationUpdateDatastoreAdminRecordArgs = {
  input: LabDatastoreAdminUpdateInput;
};

export type MutationUpdateIngestionJobArgs = {
  input: UpdateIngestionJobInput;
};

export type MutationUpdateIngestionSettingsArgs = {
  dpid: Scalars["String"]["input"];
};

export type MutationUpdateLabCategoriesArgs = {
  input: Array<LabCategoryInput>;
};

export type MutationUpdateLegalDocumentArgs = {
  input: UpdateLegalDocumentInput;
  key: Scalars["String"]["input"];
  variantId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationUpdateLegalDocumentOrgListArgs = {
  key: Scalars["String"]["input"];
  onlyIncludedOrgs: Scalars["Boolean"]["input"];
  orgIds: Array<Scalars["ID"]["input"]>;
};

export type MutationUpdateLegalDocumentVariantArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateLegalDocumentVariantInput;
  key: Scalars["String"]["input"];
};

export type MutationUpdateMsaProfileDocumentSelectionArgs = {
  input: MsaProfileDocumentSelectionUpdateInput;
};

export type MutationUpdateMsaProfileMonetizationPrefArgs = {
  input: MsaProfileMonetizationPrefUpdateInput;
};

export type MutationUpdateMsaProfileStatusArgs = {
  input: MsaProfileStatusUpdateInput;
};

export type MutationUpdateOrgAssetsArgs = {
  background?: InputMaybe<Scalars["String"]["input"]>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateOrgDetailsArgs = {
  input: UpdateOrgDetailsInput;
};

export type MutationUpdateOrgModulesArgs = {
  input: UpdateOrgModulesInput;
};

export type MutationUpdateOrgUserInviteArgs = {
  inviteId: Scalars["ID"]["input"];
  permissions: Array<Scalars["String"]["input"]>;
  roles: Array<Scalars["String"]["input"]>;
};

export type MutationUpdatePayoutMinimumArgs = {
  minimumPayoutCents: Scalars["Int"]["input"];
};

export type MutationUpdateSignatoryArgs = {
  input: SignatureDocumentSignatoryUpdateInput;
};

export type MutationUpdateStatementArgs = {
  input: StatementUpdateInput;
};

export type MutationUpdateUserPermissionsInOrgArgs = {
  id: Scalars["ID"]["input"];
  permissions: Array<Scalars["String"]["input"]>;
  roles: Array<Scalars["String"]["input"]>;
};

export type MutationUpsertPlaylistArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  imageS3Key?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  shareable?: InputMaybe<Scalars["Boolean"]["input"]>;
  trackIds: Array<Scalars["ID"]["input"]>;
};

export type MutationValidateFilesInS3Args = {
  input: ValidateFilesInput;
};

export type Notification = {
  __typename?: "Notification";
  data?: Maybe<Array<NotificationData>>;
  date: Scalars["DateTime"]["output"];
  dest?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  key: Scalars["String"]["output"];
  orgId?: Maybe<Scalars["String"]["output"]>;
  status: NotificationStatus;
  subject?: Maybe<NotificationSubject>;
  type: NotificationType;
  userId?: Maybe<Scalars["String"]["output"]>;
};

export type NotificationData = {
  __typename?: "NotificationData";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export enum NotificationStatus {
  Read = "Read",
  Unread = "Unread",
}

export type NotificationSubject = {
  __typename?: "NotificationSubject";
  avatar?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
};

export enum NotificationType {
  /** For everyone in an organisation (e.g. a new org playlist) */
  Org = "Org",
  /** For a user in the context of a specific organisation (e.g. their org role changed) */
  OrgUser = "OrgUser",
  /** For a user regardless of organisation (e.g. their stem export is ready) */
  User = "User",
}

export type NotificationsPage = {
  __typename?: "NotificationsPage";
  items: Array<Notification>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type NotificationsQueries = {
  __typename?: "NotificationsQueries";
  /** Get the unread count for the current user */
  unreadCount?: Maybe<Scalars["Int"]["output"]>;
  /** Get the current user's notifications */
  user?: Maybe<NotificationsPage>;
};

export type NotificationsQueriesUserArgs = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
};

export type Org = {
  __typename?: "Org";
  /** Create date */
  createDate: Scalars["DateTime"]["output"];
  /** Org ID */
  id: Scalars["ID"]["output"];
  /** Login methods */
  loginMethods: Array<OrgLoginMethods>;
  /** Org metadata */
  metadata?: Maybe<OrgMetadata>;
  /** Org modules */
  modules: Array<Scalars["String"]["output"]>;
  /** Org name */
  name: Scalars["String"]["output"];
  /** Parent Org ID */
  parentOrgId?: Maybe<Scalars["ID"]["output"]>;
  /** Org roles */
  roles: Array<OrgRoleX>;
  /** Workspace */
  workspace?: Maybe<Scalars["String"]["output"]>;
};

export type OrgAssetSignedUploadUrl = {
  __typename?: "OrgAssetSignedUploadUrl";
  fileName: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export enum OrgLoginMethods {
  EmailPassword = "EMAIL_PASSWORD",
  Google = "GOOGLE",
  Upstream = "UPSTREAM",
}

export type OrgMetadata = {
  __typename?: "OrgMetadata";
  /** Account manager */
  accountManager?: Maybe<OrgMetadataAccountManager>;
  /** Analytics settings */
  analytics?: Maybe<OrgMetadataAnalytics>;
  /** Assets */
  assets?: Maybe<OrgMetadataAssets>;
  /** Basic settings */
  basic?: Maybe<OrgMetadataBasic>;
  /** Other settings */
  other?: Maybe<OrgMetadataOther>;
  /** Payouts settings */
  payouts?: Maybe<OrgMetadataPayouts>;
  /** Price estimation settings */
  priceEstimation?: Maybe<OrgMetadataPriceEstimation>;
};

export type OrgMetadataAccountManager = {
  __typename?: "OrgMetadataAccountManager";
  /** Account manager email */
  email: Scalars["String"]["output"];
  /** Account manager first name */
  firstName: Scalars["String"]["output"];
  /** Account manager last name */
  lastName: Scalars["String"]["output"];
  /** Account manager phone */
  phone?: Maybe<Scalars["String"]["output"]>;
};

export type OrgMetadataAnalytics = {
  __typename?: "OrgMetadataAnalytics";
  heap?: Maybe<OrgMetadataAnalyticsHeap>;
};

export type OrgMetadataAnalyticsHeap = {
  __typename?: "OrgMetadataAnalyticsHeap";
  /** Heap enabled */
  enabled: Scalars["Boolean"]["output"];
};

export type OrgMetadataAssets = {
  __typename?: "OrgMetadataAssets";
  /** Org background file name */
  background?: Maybe<Scalars["String"]["output"]>;
  /** Org logo file name */
  logo?: Maybe<Scalars["String"]["output"]>;
};

export type OrgMetadataBasic = {
  __typename?: "OrgMetadataBasic";
  /** Deal ID */
  dealId: Scalars["ID"]["output"];
  /** Holding organization ID */
  holdingOrgId?: Maybe<Scalars["ID"]["output"]>;
  /** Parent organization ID */
  parentOrgId?: Maybe<Scalars["ID"]["output"]>;
  /** Servicing organization email */
  servicingOrgEmail: Scalars["String"]["output"];
  /** Servicing organization ID */
  servicingOrgId: Scalars["ID"]["output"];
};

export type OrgMetadataOther = {
  __typename?: "OrgMetadataOther";
  /** Org HubSpot IDs. Used to link the org to it's counterpart in the HubSpot system. */
  hubSpotIds?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type OrgMetadataPayouts = {
  __typename?: "OrgMetadataPayouts";
  /** Org billing email address */
  billingEmail?: Maybe<Scalars["String"]["output"]>;
  /** Minimum payout in USD cents; null means the platform default applies */
  minimumPayoutCents?: Maybe<Scalars["Int"]["output"]>;
  /** Org Trolley reference ID. Custom identifier that can be assigned to an entity when creating it within Trolley's system. By default, it is the same as the organization ID. */
  trolleyRefId?: Maybe<Scalars["String"]["output"]>;
  /** Org Trolley widget url. Generated based on the valid Trolley reference ID and billing email address. */
  trolleyUrl?: Maybe<Scalars["String"]["output"]>;
};

export type OrgMetadataPriceEstimation = {
  __typename?: "OrgMetadataPriceEstimation";
  /** Currency */
  currency?: Maybe<Scalars["Currency"]["output"]>;
  /** Instagram followers */
  instagramFollowers?: Maybe<Scalars["BigInt"]["output"]>;
  /** Market cap */
  marketCap?: Maybe<Scalars["BigInt"]["output"]>;
  /** Market symbol */
  marketSymbol?: Maybe<Scalars["String"]["output"]>;
  /** Number of employees */
  numberOfEmployees?: Maybe<Scalars["BigInt"]["output"]>;
  /** Public company */
  publicCompany?: Maybe<Scalars["Boolean"]["output"]>;
  /** TikTok followers */
  tikTokFollowers?: Maybe<Scalars["BigInt"]["output"]>;
};

export type OrgPermissionX = {
  __typename?: "OrgPermissionX";
  /** Permission hidden */
  hidden?: Maybe<Scalars["Boolean"]["output"]>;
  /** Permission label */
  label: Scalars["String"]["output"];
  /** Permission ID */
  name: Scalars["ID"]["output"];
};

export type OrgRoleX = {
  __typename?: "OrgRoleX";
  /** Role label */
  label: Scalars["String"]["output"];
  /** Role ID */
  name: Scalars["ID"]["output"];
  /** Role permissions */
  permissions: Array<OrgPermissionX>;
};

export type OrgUser = {
  __typename?: "OrgUser";
  /** When the user's access to the org ends */
  accessEndDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User active date */
  activeDate: Scalars["DateTime"]["output"];
  /** Current app ID */
  appId: Scalars["ID"]["output"];
  /** User deleted date */
  deletedDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User email */
  email: Scalars["String"]["output"];
  /** User first name */
  firstName: Scalars["String"]["output"];
  /** User has access to current app */
  hasAccessToApplication: Scalars["Boolean"]["output"];
  /** User ID */
  id: Scalars["ID"]["output"];
  /** User apps IDs */
  inAppIds: Array<Scalars["ID"]["output"]>;
  /** User orgs */
  inOrgs: Array<UserOrg>;
  /** User inactive date */
  inactiveDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User last name */
  lastName: Scalars["String"]["output"];
  /** User name */
  name: Scalars["String"]["output"];
  /** User org ID */
  orgId: Scalars["ID"]["output"];
  /** User permissions */
  permissions: Array<Scalars["String"]["output"]>;
  /** User picture */
  picture?: Maybe<Scalars["String"]["output"]>;
  /** User roles */
  roles: Array<Scalars["String"]["output"]>;
  /** User status */
  status: OrgUserStatus;
};

export type OrgUserInvite = {
  __typename?: "OrgUserInvite";
  /** When the invited user's access to the org ends, passed on when they accept */
  accessEndDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Invite email */
  email: Scalars["String"]["output"];
  /** Invite ID */
  id: Scalars["ID"]["output"];
  /** Last send date */
  lastSendDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Org ID */
  orgId: Scalars["ID"]["output"];
  /** Invite permissions */
  permissions: Array<Scalars["String"]["output"]>;
  /** Invite roles */
  roles: Array<Scalars["String"]["output"]>;
  /** Invite status */
  status: OrgUserInviteStatus;
  /** Workspace the invite must be accepted under */
  workspace?: Maybe<Scalars["String"]["output"]>;
};

export type OrgUserInviteBatch = {
  __typename?: "OrgUserInviteBatch";
  /** Creation date */
  createdDate: Scalars["DateTime"]["output"];
  /** Invites that could not be sent */
  failed: Scalars["Int"]["output"];
  /** Batch ID */
  id: Scalars["ID"]["output"];
  /** Entered values skipped because they are not deliverable email addresses */
  invalid: Array<Scalars["String"]["output"]>;
  /** Org ID */
  orgId: Scalars["ID"]["output"];
  /** Deactivated members that could not be made active again */
  reactivateFailed: Scalars["Int"]["output"];
  /** Deactivated members made active again before sending */
  reactivated: Scalars["Int"]["output"];
  /** Invites created and queued for sending */
  requested: Scalars["Int"]["output"];
  /** Invites sent so far */
  sent: Scalars["Int"]["output"];
  /** Addresses skipped because they are members or already invited */
  skipped: Scalars["Int"]["output"];
  /** Batch status */
  status: OrgUserInviteBatchStatus;
};

export enum OrgUserInviteBatchStatus {
  /** Every invite was sent */
  Completed = "completed",
  /** At least one invite could not be sent */
  Error = "error",
  /** Processor is sending */
  Processing = "processing",
  /** Accepted and waiting for the processor */
  Queued = "queued",
}

export type OrgUserInviteInput = {
  /** Invite email */
  emails: Array<Scalars["String"]["input"]>;
  /** Invite permissions */
  permissions: Array<Scalars["String"]["input"]>;
  /** Invite roles */
  roles: Array<Scalars["String"]["input"]>;
};

export type OrgUserInviteLookupResult = {
  __typename?: "OrgUserInviteLookupResult";
  /** Normalised email address */
  email: Scalars["String"]["output"];
  /** What sending an invite to this address would do */
  status: OrgUserInviteLookupStatus;
};

export enum OrgUserInviteLookupStatus {
  /** Active user of the org */
  Active = "active",
  /** Member whose access to the org expired, needs reactivating rather than inviting */
  Expired = "expired",
  /** Deactivated member of the org, needs reactivating rather than inviting */
  Inactive = "inactive",
  /** Has a pending invite already */
  Pending = "pending",
  /** No org user and no pending invite, an invite can be sent */
  Unknown = "unknown",
}

export type OrgUserInviteSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<OrgUserInviteSortKey>;
};

export enum OrgUserInviteSortKey {
  Email = "email",
  LastSendDate = "lastSendDate",
  Status = "status",
}

export enum OrgUserInviteStatus {
  Accepted = "accepted",
  Expired = "expired",
  Pending = "pending",
  Removed = "removed",
}

export type OrgUserInvitesPage = {
  __typename?: "OrgUserInvitesPage";
  /** Invites */
  invites: Array<OrgUserInvite>;
  /** Limit */
  limit: Scalars["Int"]["output"];
  /** Offset */
  offset: Scalars["Int"]["output"];
  /** Org ID */
  orgId: Scalars["ID"]["output"];
  /** Query */
  query?: Maybe<Scalars["String"]["output"]>;
  /** Total */
  total: Scalars["Int"]["output"];
};

export enum OrgUserStatus {
  Active = "active",
  Deleted = "deleted",
  Expired = "expired",
  Inactive = "inactive",
}

export type OrgUsersPage = {
  __typename?: "OrgUsersPage";
  /** App ID */
  appId: Scalars["ID"]["output"];
  /** Include permissions */
  includePermissions: Scalars["Boolean"]["output"];
  /** Last page */
  isLastPage: Scalars["Boolean"]["output"];
  /** Limit */
  limit: Scalars["Int"]["output"];
  /** Offset */
  offset: Scalars["Int"]["output"];
  /** Org ID */
  orgId: Scalars["ID"]["output"];
  /** Query */
  query: Scalars["String"]["output"];
  /** Total */
  total: Scalars["Int"]["output"];
  /** Users */
  users: Array<OrgUser>;
};

export type OrgsPage = {
  __typename?: "OrgsPage";
  /** Limit */
  limit: Scalars["Int"]["output"];
  /** Offset */
  offset: Scalars["Int"]["output"];
  /** Orgs */
  orgs: Array<Org>;
  /** Query */
  query?: Maybe<Scalars["String"]["output"]>;
  /** Total */
  total: Scalars["Int"]["output"];
};

export type OrgsSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<OrgsSortKey>;
};

export enum OrgsSortKey {
  Name = "name",
}

export type Payout = {
  __typename?: "Payout";
  /** amountCents as a USD decimal, e.g. 120.50, for exports; always set */
  amount?: Maybe<Scalars["String"]["output"]>;
  amountCents: Scalars["Int"]["output"];
  createDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Also the Trolley payment's external id */
  id: Scalars["String"]["output"];
  orgId: Scalars["String"]["output"];
  orgName?: Maybe<Scalars["String"]["output"]>;
  paidAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Trolley returned the payment, before or after paying it; its amount is back in the org's balance */
  returned?: Maybe<Scalars["Boolean"]["output"]>;
  /** When the return was seen in Trolley */
  returnedAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: PayoutStatus;
  trolleyPaymentId?: Maybe<Scalars["String"]["output"]>;
  trolleyStatus?: Maybe<Scalars["String"]["output"]>;
};

/** The current org's payout balance; all amounts are USD cents */
export type PayoutBalance = {
  __typename?: "PayoutBalance";
  /** Unpaid and batched ledger items; can be negative */
  balanceCents: Scalars["Int"]["output"];
  currency: Scalars["String"]["output"];
  /** The org is paid once its balance reaches this amount */
  minimumPayoutCents: Scalars["Int"]["output"];
  /** Whether the org has an active Trolley recipient; null when Trolley can't be reached */
  payoutSetupComplete?: Maybe<Scalars["Boolean"]["output"]>;
  /** Part of the balance in a Trolley batch that hasn't been paid yet */
  pendingPayoutCents: Scalars["Int"]["output"];
};

export type PayoutBatch = {
  __typename?: "PayoutBatch";
  /** Last change; while Creating, every prepared org updates it */
  changeDate?: Maybe<Scalars["DateTime"]["output"]>;
  createDate?: Maybe<Scalars["DateTime"]["output"]>;
  createUser?: Maybe<SsoUser>;
  createdBy?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  /** Payouts the last complete refresh found a problem with */
  issues?: Maybe<Array<PayoutBatchIssue>>;
  /** Why the last background task stopped: a sentence, or a Payouts.* message key; null once one finished */
  lastSyncError?: Maybe<Scalars["String"]["output"]>;
  lastSyncedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Orgs selected for the batch; 0 on batches created before it was recorded */
  orgCount: Scalars["Int"]["output"];
  paymentCount: Scalars["Int"]["output"];
  payouts?: Maybe<Array<Payout>>;
  /** Selected orgs prepared so far, skipped or not; while Creating it shows the progress */
  preparedCount: Scalars["Int"]["output"];
  reviewReason?: Maybe<Scalars["String"]["output"]>;
  skipped: Array<PayoutSkippedOrg>;
  status: PayoutBatchStatus;
  /** How far the running or last refresh got */
  syncProgress?: Maybe<PayoutBatchSyncProgress>;
  /** What the running or last background task does */
  syncTask?: Maybe<PayoutBatchTask>;
  /** A refresh or delete is running in the background */
  syncing?: Maybe<Scalars["Boolean"]["output"]>;
  totalCents: Scalars["Int"]["output"];
  trolleyBatchId?: Maybe<Scalars["String"]["output"]>;
  /** Set once the batch was sent to Trolley */
  trolleyRequestedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type PayoutBatchPayoutsArgs = {
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PayoutBatchIssue = {
  __typename?: "PayoutBatchIssue";
  kind: PayoutIssueKind;
  message: Scalars["String"]["output"];
  payout: Payout;
  /** Whether releasePayouts can return its items to the balance */
  releasable: Scalars["Boolean"]["output"];
  /** The payment's status in Trolley when the problem was found; null when Trolley has no payment */
  trolleyStatus?: Maybe<Scalars["String"]["output"]>;
};

export type PayoutBatchPage = {
  __typename?: "PayoutBatchPage";
  items: Array<PayoutBatch>;
  total: Scalars["Int"]["output"];
};

/**
 * Batches are created open in Trolley; Finance starts processing them in the
 * Trolley dashboard. NeedsReview means Trolley didn't match our records or its
 * outcome is unknown, so an admin must check it.
 */
export enum PayoutBatchStatus {
  Cancelled = "Cancelled",
  Completed = "Completed",
  Creating = "Creating",
  NeedsReview = "NeedsReview",
  Open = "Open",
  Processing = "Processing",
}

/** Payments a refresh listed from Trolley and applied */
export type PayoutBatchSyncProgress = {
  __typename?: "PayoutBatchSyncProgress";
  applied: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

/** What a batch's background task does */
export enum PayoutBatchTask {
  Delete = "Delete",
  Refresh = "Refresh",
}

/** A message in an org's payout conversation */
export type PayoutComment = {
  __typename?: "PayoutComment";
  /** Set when the comment put the org on hold or released it */
  action?: Maybe<PayoutCommentAction>;
  /** Plain text; URLs are shown as links */
  body: Scalars["String"]["output"];
  createDate?: Maybe<Scalars["DateTime"]["output"]>;
  createUser?: Maybe<SsoUser>;
  createdBy?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  orgId: Scalars["String"]["output"];
};

export enum PayoutCommentAction {
  /** The comment put the org on hold */
  Hold = "Hold",
  /** The comment released the org */
  Release = "Release",
}

/** An org's payout balance details */
export type PayoutEligibleOrg = {
  __typename?: "PayoutEligibleOrg";
  adjustmentCents: Scalars["Int"]["output"];
  adjustments?: Maybe<Scalars["String"]["output"]>;
  /** The cents fields as USD decimals, e.g. 120.50, for exports; always set */
  balance?: Maybe<Scalars["String"]["output"]>;
  balanceCents: Scalars["Int"]["output"];
  /** Messages in the org's payout conversation */
  commentCount: Scalars["Int"]["output"];
  /** When the org was put on hold; set on held orgs only */
  heldAt?: Maybe<Scalars["DateTime"]["output"]>;
  itemCount: Scalars["Int"]["output"];
  legacy?: Maybe<Scalars["String"]["output"]>;
  legacyCents: Scalars["Int"]["output"];
  /** The org's legacy marketplace user; null unless the org came from the marketplace */
  marketplaceUserId?: Maybe<Scalars["Int"]["output"]>;
  minimumPayout?: Maybe<Scalars["String"]["output"]>;
  minimumPayoutCents: Scalars["Int"]["output"];
  orgId: Scalars["String"]["output"];
  orgName?: Maybe<Scalars["String"]["output"]>;
  statementCents: Scalars["Int"]["output"];
  statements?: Maybe<Scalars["String"]["output"]>;
  /** Active and Unknown orgs can be batched */
  trolleyStatus: PayoutTrolleyStatus;
};

export type PayoutEligibleOrgPage = {
  __typename?: "PayoutEligibleOrgPage";
  items: Array<PayoutEligibleOrg>;
  total: Scalars["Int"]["output"];
};

export type PayoutEligibleSort = {
  direction: SortDirection;
  key?: InputMaybe<PayoutEligibleSortKey>;
};

export enum PayoutEligibleSortKey {
  BalanceCents = "balanceCents",
}

/** Why a payout needs an admin, as the last complete refresh found it */
export enum PayoutIssueKind {
  DifferentAmount = "DifferentAmount",
  DifferentRecipient = "DifferentRecipient",
  /** Trolley failed the payment; its items stay claimed in case Finance re-sends it */
  Failed = "Failed",
  /** Trolley's batch has no payment for it */
  Missing = "Missing",
  /** Trolley pays a payout whose items already returned to the balance */
  PaidAfterRelease = "PaidAfterRelease",
  UnknownStatus = "UnknownStatus",
}

/** Where a ledger item's amount comes from */
export enum PayoutItemSource {
  /** A correction, e.g. a returned payment credited back */
  Adjustment = "Adjustment",
  /** The org's balance on the legacy marketplace, refreshed until it is paid */
  LegacyOpening = "LegacyOpening",
  /** A statement paid by the statement processor */
  Statement = "Statement",
}

export enum PayoutItemStatus {
  /** Claimed by a payout in a Trolley batch that hasn't been paid yet */
  Batched = "Batched",
  Paid = "Paid",
  Unpaid = "Unpaid",
}

export type PayoutQueries = {
  __typename?: "PayoutQueries";
  /** Null for an unknown batch */
  batch?: Maybe<PayoutBatch>;
  /** Payout batches, newest first */
  batches?: Maybe<PayoutBatchPage>;
  /** An org's payout conversation, oldest first */
  comments?: Maybe<Array<PayoutComment>>;
  /** Orgs that can be paid in the next batch, highest balance first unless sorted; every match without a limit */
  eligible?: Maybe<PayoutEligibleOrgPage>;
  /** Orgs on hold, whatever their balance; latest hold first */
  held?: Maybe<Array<PayoutEligibleOrg>>;
};

export type PayoutQueriesBatchArgs = {
  id: Scalars["String"]["input"];
};

export type PayoutQueriesBatchesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PayoutQueriesCommentsArgs = {
  orgId: Scalars["String"]["input"];
};

export type PayoutQueriesEligibleArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<PayoutEligibleSort>;
  trolleyStatuses?: InputMaybe<Array<PayoutTrolleyStatus>>;
};

export type PayoutQueriesHeldArgs = {
  search?: InputMaybe<Scalars["String"]["input"]>;
};

/** An org left out of a new batch, and why */
export type PayoutSkippedOrg = {
  __typename?: "PayoutSkippedOrg";
  orgId: Scalars["String"]["output"];
  orgName?: Maybe<Scalars["String"]["output"]>;
  reason: Scalars["String"]["output"];
};

export enum PayoutStatus {
  Cancelled = "Cancelled",
  Failed = "Failed",
  Open = "Open",
  Paid = "Paid",
  Processing = "Processing",
}

export enum PayoutTrolleyStatus {
  /** An active Trolley recipient; the org can be batched */
  Active = "Active",
  /** A Trolley recipient that isn't active yet, e.g. onboarding unfinished */
  NotActive = "NotActive",
  /** No Trolley recipient for the org, or Trolley deleted it */
  NotSetUp = "NotSetUp",
  /** No stored status and no completed refresh yet; batching checks Trolley */
  Unknown = "Unknown",
}

/** A legal document the current user still needs to accept. Mirrors LegalDocument fields needed by the agreement modal. */
export type PendingLegalAgreement = {
  __typename?: "PendingLegalAgreement";
  /** Confirmations the user must tick to accept */
  confirmations: Array<LegalConfirmation>;
  /** Document body (HTML) */
  content: Scalars["String"]["output"];
  /** Active document version ID (used as the target of recordLegalAgreement) */
  documentId: Scalars["ID"]["output"];
  /** Date this version takes effect */
  effectiveDate: Scalars["DateTime"]["output"];
  /** Stable key (matches the input to pendingLegalAgreements) */
  key: Scalars["String"]["output"];
  /** Display name */
  name: Scalars["String"]["output"];
  /** Version the user previously accepted (null if they have never accepted any version of this document) */
  previousAcceptedVersion?: Maybe<Scalars["Int"]["output"]>;
  /** Whether the user must scroll to the end of the document before accepting */
  requiresScrollToAccept: Scalars["Boolean"]["output"];
  /** Document version the user is being asked to accept */
  version: Scalars["Int"]["output"];
};

export type Playlist = {
  __typename?: "Playlist";
  createdBy?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  duration: Scalars["Int"]["output"];
  hasCustomImage: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  imageGuid?: Maybe<Scalars["String"]["output"]>;
  imageUrl: Scalars["String"]["output"];
  isOwner: Scalars["Boolean"]["output"];
  liked: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  segmentTracksCount: Scalars["Int"]["output"];
  shareable: Scalars["Boolean"]["output"];
  totalCount: Scalars["Int"]["output"];
  trackIds: Array<Scalars["String"]["output"]>;
  tracks: TracksPage;
  userId?: Maybe<Scalars["String"]["output"]>;
};

export type PlaylistImageUrlArgs = {
  size?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlaylistTracksArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlaylistList = {
  __typename?: "PlaylistList";
  results: Array<Playlist>;
  total: Scalars["Int"]["output"];
};

export type PlaylistQueries = {
  __typename?: "PlaylistQueries";
  /** Get a single playlist by id */
  byId?: Maybe<Playlist>;
  /** Shared playlist queries */
  shared?: Maybe<SharedPlaylistQueries>;
};

export type PlaylistQueriesByIdArgs = {
  id: Scalars["ID"]["input"];
};

export type PlaylistsQueries = {
  __typename?: "PlaylistsQueries";
  /** Get curated playlists */
  curated?: Maybe<CuratedPlaylistQueries>;
  /** Get the current user's liked playlists */
  liked?: Maybe<Array<Playlist>>;
  /** Get recently played playlists for the current user */
  recent?: Maybe<Array<Playlist>>;
  /** Get the current user's team playlists */
  team?: Maybe<Array<Playlist>>;
  /** Get the current user's personal playlists */
  user?: Maybe<Array<Playlist>>;
};

export type PlaylistsQueriesCuratedArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PlaylistsQueriesRecentArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PortableText = {
  __typename?: "PortableText";
  /** The key of the portable text */
  _key?: Maybe<Scalars["String"]["output"]>;
  /** The type of the portable text */
  _type?: Maybe<Scalars["String"]["output"]>;
  /** The children of the portable text */
  children?: Maybe<Array<Maybe<PortableTextChildren>>>;
  /** The list item of the portable text */
  listItem?: Maybe<Scalars["String"]["output"]>;
  /** The style of the portable text */
  style?: Maybe<Scalars["String"]["output"]>;
};

export type PortableTextChildren = {
  __typename?: "PortableTextChildren";
  /** The key of the portable text */
  _key?: Maybe<Scalars["String"]["output"]>;
  /** The type of the portable text */
  _type?: Maybe<Scalars["String"]["output"]>;
  /** The marks of the portable text */
  marks?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The text of the portable text */
  text?: Maybe<Scalars["String"]["output"]>;
};

export type PreparedChannel = {
  __typename?: "PreparedChannel";
  channelTitle?: Maybe<Scalars["String"]["output"]>;
  duplicate: Scalars["Boolean"]["output"];
  handle?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  platform: ChannelPlatform;
};

export type PreparedChannelResult = ChannelLookupError | PreparedChannel;

export type Query = {
  __typename?: "Query";
  /** Get App */
  app: LabApp;
  /** Get differences between dev and production */
  appDevDifferences: Array<LabAppDevDifference>;
  /** Get Apps */
  apps: Array<LabApp>;
  /** Query individual artists */
  artist: ArtistQueries;
  /** Query lists of artists */
  artists: ArtistsQueries;
  /** Return analyzed brief */
  briefAnalysis: BriefAnalysis;
  /** Fetch a bulk-download (org-scoped); includes a download link when completed */
  bulkDownload?: Maybe<BulkDownload>;
  /** Query lists of channels */
  channels: ChannelsQueries;
  /** Single clearance assigned to user organization based on provided clearance id */
  clearance: Clearance;
  /** All clearances assigned to user organization optionally filtered by client id */
  clearances: ClearancePage;
  /** Single client assigned to user organization based on provided client id */
  client: Client;
  /** All clients assigned to user organization */
  clients: ClientPage;
  /** Query collections of channels */
  collections: CollectionsQueries;
  /** Get single commercial license */
  commercialLicense: CommercialLicense;
  /** Get commercial licenses */
  commercialLicenses: CommercialLicensePage;
  /** Get datastore records for admin */
  datastoreAdminRecords: LabDatastoreAdminResponse;
  /** Query distribution partner integrations */
  distribution: DistributionQueries;
  /** Get available Gemini models. When labAppId is provided and the app has a GEMINI_API_KEY secret, models are scoped to that key. */
  geminiModels: Array<GeminiModel>;
  /** Single client assigned to user organization based on provided client id extended with assigned clearances */
  getClientDetails?: Maybe<Client>;
  getMsaDocument: MsaDocumentGetResponse;
  getMsaLogEntriesByUserKey?: Maybe<Array<MsaLogEntry>>;
  getMsaProfilesByStatus: Array<Maybe<MsaProfile>>;
  getMsaSurveyResponses?: Maybe<Array<Maybe<MsaLogEntry>>>;
  /** Get a single ingestion job by ID */
  ingestionJob?: Maybe<IngestionJob>;
  /** Get ingestion jobs for the current org with pagination and search */
  ingestionJobs: IngestionJobsResult;
  /** Get ingestion settings for the current org */
  ingestionSettings?: Maybe<IngestionSettingsResult>;
  /** Get Lab Categories */
  labCategories: Array<LabCategory>;
  /** Execute Labs Service Command */
  labsServiceCommand: LabsCommandResult;
  /** Acceptances of legal documents, newest first, optionally for one document key */
  legalAgreements: LegalAgreementPage;
  /** Get a legal document by key. When version is supplied, returns that historic version (read-only on the client); otherwise returns the active row of the org version variantId, or of the default version. */
  legalDocument: LegalDocument;
  /** Get the change log for a legal document key (newest first) */
  legalDocumentChangeLog: LegalDocumentChangeLogPage;
  /** Default version, org versions and excluded orgs of a legal document */
  legalDocumentOrgVersions: LegalDocumentOrgVersions;
  /** List legal documents */
  legalDocuments: LegalDocumentPage;
  /** Get single library license */
  libraryLicense: LibraryLicense;
  /** Get list of library licenses */
  libraryLicenses: Array<LibraryLicense>;
  /** Get summary data for library licenses */
  libraryLicensesSummary: LibraryLicensesSummary;
  /** Query lists of notifications */
  notifications: NotificationsQueries;
  /** Get org */
  org: Org;
  /** Classify addresses before inviting: member, inactive, pending or available */
  orgUserInviteLookup: Array<OrgUserInviteLookupResult>;
  /** Get all invites */
  orgUserInvites: OrgUserInvitesPage;
  /** Get all org users */
  orgUsers: OrgUsersPage;
  /** Get orgs assigned to user */
  orgs: OrgsPage;
  /** The current org's payout balance */
  payoutBalance: PayoutBalance;
  /** Payout administration queries */
  payouts: PayoutQueries;
  /** Returns the subset of the requested document keys that the current user still needs to accept. Each key resolves to the current org's version of the document (its org version, else the default). Keys with no active document, keys the org is excluded from, or where the user has already accepted the latest version (or any historic version, if requiresReagreement is false), are omitted. */
  pendingLegalAgreements: Array<PendingLegalAgreement>;
  /** Query individual playlists */
  playlist: PlaylistQueries;
  /** Query lists of playlists */
  playlists: PlaylistsQueries;
  /** Get user's recent searches */
  recentSearches: Array<RecentSearch>;
  /** Get a report definition including its parameter options */
  report: ReportDefinition;
  /** Run a report and return only its flat rows, for exports */
  reportRows: Array<Scalars["JSON"]["output"]>;
  /** List all available reports */
  reports: Array<ReportDefinition>;
  /** A single resource by id */
  resource: Resource;
  /** All resources available to the current organization */
  resources: ResourcePage;
  /** Run a report with the given parameter values */
  runReport: ReportResult;
  /** Search for music */
  search: SearchQueries;
  /** Get a shared track resolved from the request's share token */
  sharedTrack?: Maybe<Track>;
  signatureDocument: SignatureDocument;
  signatureDocumentTemplate: SignatureDocumentTemplate;
  /** Single statement assigned to user organization based on provided statement id */
  statement: Statement;
  /** Statement import queries */
  statementImports: StatementImportQueries;
  /** Payment statuses the user organization has statements in */
  statementPaymentStatuses: Array<StatementPaymentStatus>;
  /** Services the user organization has statements for */
  statementServices: Array<Scalars["String"]["output"]>;
  /** Period years for statements assigned to user organization */
  statementYears: Array<Scalars["Int"]["output"]>;
  /** Statements assigned to user organization */
  statements: StatementPage;
  /** Query lists of stems */
  stems: StemsQueries;
  tikTokOembed?: Maybe<TikTokOembed>;
  /** Get a single track by id */
  track?: Maybe<Track>;
  /** Query lists of tracks */
  tracks: TracksQueries;
  user: CurrentUser;
  verifyMsaProfile: MsaProfile;
  youtubeChannel?: Maybe<YouTubeChannelMetadata>;
};

export type QueryAppArgs = {
  env?: InputMaybe<LabAppEnvironment>;
  id: Scalars["String"]["input"];
};

export type QueryAppDevDifferencesArgs = {
  id: Scalars["String"]["input"];
};

export type QueryAppsArgs = {
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryBriefAnalysisArgs = {
  brief: Scalars["String"]["input"];
};

export type QueryBulkDownloadArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryClearanceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryClearancesArgs = {
  clientId?: InputMaybe<Scalars["ID"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  platform?: InputMaybe<ClearanceMediaPlatform>;
  sortBy?: InputMaybe<ClearanceSort>;
  status?: InputMaybe<ClearanceStatus>;
  type?: InputMaybe<ClearanceMediaType>;
};

export type QueryClientArgs = {
  clientId: Scalars["ID"]["input"];
};

export type QueryClientsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  sortBy?: InputMaybe<ClientSort>;
};

export type QueryCommercialLicenseArgs = {
  id: Scalars["String"]["input"];
};

export type QueryCommercialLicensesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<CommercialLicenseSort>;
  status?: InputMaybe<CommercialLicenseStatus>;
};

export type QueryDatastoreAdminRecordsArgs = {
  input: LabDatastoreAdminQueryInput;
};

export type QueryGeminiModelsArgs = {
  env?: InputMaybe<LabAppEnvironment>;
  labAppId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetClientDetailsArgs = {
  clientId: Scalars["ID"]["input"];
};

export type QueryGetMsaDocumentArgs = {
  key: Scalars["String"]["input"];
};

export type QueryGetMsaLogEntriesByUserKeyArgs = {
  key: Scalars["String"]["input"];
};

export type QueryGetMsaProfilesByStatusArgs = {
  status: MsaProfileStatus;
};

export type QueryIngestionJobArgs = {
  jobId: Scalars["ID"]["input"];
};

export type QueryIngestionJobsArgs = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryLabsServiceCommandArgs = {
  input: LabsCommandInput;
};

export type QueryLegalAgreementsArgs = {
  key?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryLegalDocumentArgs = {
  key: Scalars["String"]["input"];
  variantId?: InputMaybe<Scalars["ID"]["input"]>;
  version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryLegalDocumentChangeLogArgs = {
  key: Scalars["String"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryLegalDocumentOrgVersionsArgs = {
  key: Scalars["String"]["input"];
};

export type QueryLegalDocumentsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryLibraryLicenseArgs = {
  id: Scalars["String"]["input"];
};

export type QueryLibraryLicensesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<LibraryLicenseSort>;
  years?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type QueryLibraryLicensesSummaryArgs = {
  query?: InputMaybe<Scalars["String"]["input"]>;
  years?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type QueryOrgArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryOrgUserInviteLookupArgs = {
  emails: Array<Scalars["String"]["input"]>;
};

export type QueryOrgUserInvitesArgs = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<OrgUserInviteSort>;
  statuses?: InputMaybe<Array<OrgUserInviteStatus>>;
};

export type QueryOrgUsersArgs = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  query?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryOrgsArgs = {
  limit: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<OrgsSort>;
};

export type QueryPendingLegalAgreementsArgs = {
  keys: Array<Scalars["String"]["input"]>;
};

export type QueryRecentSearchesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryReportArgs = {
  key: Scalars["String"]["input"];
};

export type QueryReportRowsArgs = {
  key: Scalars["String"]["input"];
  parameters?: InputMaybe<Array<ReportParameterValueInput>>;
};

export type QueryResourceArgs = {
  id: Scalars["String"]["input"];
};

export type QueryResourcesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<ResourceSort>;
};

export type QueryRunReportArgs = {
  key: Scalars["String"]["input"];
  parameters?: InputMaybe<Array<ReportParameterValueInput>>;
};

export type QuerySearchArgs = {
  filter?: InputMaybe<Array<SearchFilterInput>>;
  query: Scalars["String"]["input"];
  type: SearchType;
};

export type QuerySignatureDocumentArgs = {
  input: SignatureDocumentQueryInput;
};

export type QuerySignatureDocumentTemplateArgs = {
  templateKey: Scalars["String"]["input"];
};

export type QueryStatementArgs = {
  id: Scalars["String"]["input"];
};

export type QueryStatementsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  months?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  service?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<StatementSort>;
  statuses?: InputMaybe<Array<StatementPaymentStatus>>;
  years?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type QueryTikTokOembedArgs = {
  url: Scalars["String"]["input"];
};

export type QueryTrackArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryVerifyMsaProfileArgs = {
  key: Scalars["String"]["input"];
};

export type QueryYoutubeChannelArgs = {
  url: Scalars["String"]["input"];
};

export type RateLimitConfig = {
  __typename?: "RateLimitConfig";
  /** App-wide rate limit */
  app?: Maybe<RateLimitSettings>;
  /** Per-user rate limit */
  user?: Maybe<RateLimitSettings>;
};

export type RateLimitConfigInput = {
  /** App-wide rate limit */
  app?: InputMaybe<RateLimitSettingsInput>;
  /** Per-user rate limit */
  user?: InputMaybe<RateLimitSettingsInput>;
};

export type RateLimitSettings = {
  __typename?: "RateLimitSettings";
  /** Maximum number of requests */
  maxRequests?: Maybe<Scalars["Int"]["output"]>;
  /** Enable rate limiting */
  useRateLimiting?: Maybe<Scalars["Boolean"]["output"]>;
  /** Time window in seconds */
  windowSeconds?: Maybe<Scalars["Int"]["output"]>;
};

export type RateLimitSettingsInput = {
  /** Maximum number of requests */
  maxRequests?: InputMaybe<Scalars["Int"]["input"]>;
  /** Enable rate limiting */
  useRateLimiting?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Time window in seconds */
  windowSeconds?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RateLimits = {
  __typename?: "RateLimits";
  /** App-wide calls */
  appWide?: Maybe<RateLimitConfig>;
  /** Datastore calls */
  dataStore?: Maybe<RateLimitConfig>;
  /** Gemini AI calls */
  gemini?: Maybe<RateLimitConfig>;
  /** Music Search calls */
  musicSearch?: Maybe<RateLimitConfig>;
};

export type RateLimitsInput = {
  /** App-wide calls */
  appWide?: InputMaybe<RateLimitConfigInput>;
  /** Datastore calls */
  dataStore?: InputMaybe<RateLimitConfigInput>;
  /** Gemini AI calls */
  gemini?: InputMaybe<RateLimitConfigInput>;
  /** Music Search calls */
  musicSearch?: InputMaybe<RateLimitConfigInput>;
};

export type RecentSearch = {
  __typename?: "RecentSearch";
  /** Search filters */
  filter?: Maybe<Array<SearchFilterOutput>>;
  /** Unique identifier for the recent search entry */
  id: Scalars["String"]["output"];
  /** Search query string */
  query: Scalars["String"]["output"];
  /** Search type */
  type: SearchType;
  /** URL search result details */
  urlResult?: Maybe<UrlResult>;
};

export type RecordLegalAgreementInput = {
  /** Labels of every confirmation the user ticked. Must match the document's confirmation labels exactly. */
  acceptedConfirmations: Array<Scalars["String"]["input"]>;
  /** Base64-encoded pipe-joined client fingerprint material (userAgent, screen, timezone, language, cpuClass). Combined with the server-observed client IP to produce an opaque proof-of-client token stored alongside the agreement. */
  clientInfo: Scalars["String"]["input"];
  /** ID of the document version the user is accepting */
  documentId: Scalars["ID"]["input"];
};

export type Release = {
  __typename?: "Release";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ReportColumn = {
  __typename?: "ReportColumn";
  key: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  type: ReportColumnType;
};

export enum ReportColumnType {
  Date = "DATE",
  Number = "NUMBER",
  String = "STRING",
}

export type ReportDefinition = {
  __typename?: "ReportDefinition";
  columns: Array<ReportColumn>;
  description: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  parameters: Array<ReportParameter>;
};

/** A user input of a report. The client renders it as a form field and submits the value as a string. */
export type ReportParameter = {
  __typename?: "ReportParameter";
  /** Default value, serialized as a string */
  defaultValue?: Maybe<Scalars["String"]["output"]>;
  helpText?: Maybe<Scalars["String"]["output"]>;
  label: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** Choices for SELECT parameters. Only resolved when a single report is queried. */
  options?: Maybe<Array<ReportParameterOption>>;
  placeholder?: Maybe<Scalars["String"]["output"]>;
  required: Scalars["Boolean"]["output"];
  type: ReportParameterType;
};

export type ReportParameterOption = {
  __typename?: "ReportParameterOption";
  label: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export enum ReportParameterType {
  Date = "DATE",
  Number = "NUMBER",
  Select = "SELECT",
  Text = "TEXT",
  Toggle = "TOGGLE",
}

export type ReportParameterValueInput = {
  name: Scalars["String"]["input"];
  value?: InputMaybe<Scalars["String"]["input"]>;
};

export type ReportResult = {
  __typename?: "ReportResult";
  columns: Array<ReportColumn>;
  generatedAt: Scalars["DateTime"]["output"];
  key: Scalars["String"]["output"];
  /** One object per row, keyed by column key. Numbers are numbers, dates are ISO strings. */
  rows: Array<Scalars["JSON"]["output"]>;
};

export type Resource = {
  __typename?: "Resource";
  /** Content of the resource */
  content: Array<ResourceContent>;
  /** Description of the resource */
  description: Scalars["String"]["output"];
  /** Title of the resource */
  title: Scalars["String"]["output"];
};

export type ResourceColumns = {
  __typename?: "ResourceColumns";
  /** Any custom text sections in the content item */
  customTextSection?: Maybe<ResourceCustomTextSection>;
  /** Any documents in the content item */
  document?: Maybe<ResourceDocument>;
  /** Any iframes in the content item */
  iframe?: Maybe<ResourceIframe>;
  /** Any music player tracks in the content item */
  musicPlayerTracks?: Maybe<Array<ResourceMusicPlayerTracksItem>>;
  /** Any text sections in the content item */
  textSection?: Maybe<ResourceTextSection>;
  /** Any videos in the content item */
  video?: Maybe<ResourceVideo>;
};

export type ResourceContent = {
  __typename?: "ResourceContent";
  /** Columns of the content item */
  columns: ResourceColumns;
  /** Title of the content item */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Type of the content item */
  type: Scalars["String"]["output"];
};

export type ResourceCustomTextSection = {
  __typename?: "ResourceCustomTextSection";
  /** The portable text of the custom text section (read with react-portable-text) */
  portableText: Array<PortableText>;
  /** The width of the custom text section */
  width?: Maybe<Scalars["Int"]["output"]>;
};

export type ResourceDocument = {
  __typename?: "ResourceDocument";
  /** The id of the document */
  id: Scalars["String"]["output"];
  /** Whether the document is downloadable */
  isDownloadable?: Maybe<Scalars["Boolean"]["output"]>;
  /** The title of the document */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The date of the document */
  uploadDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** The URL of the document */
  url: Scalars["String"]["output"];
};

export type ResourceIframe = {
  __typename?: "ResourceIframe";
  /** The URL of the iframe */
  url: Scalars["String"]["output"];
};

export type ResourceList = {
  __typename?: "ResourceList";
  /** Description of the resource */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier for the resource */
  id: Scalars["String"]["output"];
  /** Name of the resource */
  name: Scalars["String"]["output"];
  /** Type of the resource */
  type: Scalars["String"]["output"];
  /** Date of last update */
  updated: Scalars["DateTime"]["output"];
};

export type ResourceMusicPlayerTracksItem = {
  __typename?: "ResourceMusicPlayerTracksItem";
  /** Whether the music player track is downloadable */
  isDownloadable?: Maybe<Scalars["Boolean"]["output"]>;
  /** The title of the music player track */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the music player track */
  url: Scalars["String"]["output"];
};

export type ResourcePage = {
  __typename?: "ResourcePage";
  /** List of resources */
  items: Array<ResourceList>;
  /** Total number of resources */
  total: Scalars["Int"]["output"];
};

export type ResourceSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<ResourceSortKey>;
};

export enum ResourceSortKey {
  Name = "name",
  Updated = "updated",
}

export type ResourceTextSection = {
  __typename?: "ResourceTextSection";
  /** The description of the text section */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The title of the text section */
  title?: Maybe<Scalars["String"]["output"]>;
  /** The width of the text section */
  width?: Maybe<Scalars["Int"]["output"]>;
};

export type ResourceVideo = {
  __typename?: "ResourceVideo";
  /** The URL of the video */
  url?: Maybe<Scalars["String"]["output"]>;
  /** The width of the video */
  width?: Maybe<Scalars["Int"]["output"]>;
};

export type SavedMediaFile = {
  __typename?: "SavedMediaFile";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  size: Scalars["Int"]["output"];
  type: Scalars["String"]["output"];
  uploadComplete: Scalars["Boolean"]["output"];
};

export type SavedMediaFileInput = {
  id: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  size: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
  uploadComplete: Scalars["Boolean"]["input"];
};

export type SearchArgs = {
  __typename?: "SearchArgs";
  /** Search filters */
  filter?: Maybe<Array<SearchFilterOutput>>;
  /** Search query string */
  query: Scalars["String"]["output"];
  /** Search type */
  type: SearchType;
};

export type SearchFilterInput = {
  name: SearchFilterName;
  values: Array<Scalars["String"]["input"]>;
};

export enum SearchFilterName {
  AllComposersInApprovedSocieties = "all_composers_in_approved_societies",
  Arousal = "arousal",
  AudienceAges = "audience_ages",
  AudienceGender = "audience_gender",
  AudienceRegions = "audience_regions",
  Bpm = "bpm",
  BrandAttributes = "brand_attributes",
  Content = "content",
  Curateability = "curateability",
  Duration = "duration",
  Energy = "energy",
  Engagement = "engagement",
  Explicit = "explicit",
  Grooviness = "grooviness",
  Harmony = "harmony",
  IndustrySuitability = "industry_suitability",
  Instruments = "instruments",
  Key = "key",
  Level1Genres = "level1_genres",
  Level2Genres = "level2_genres",
  Loudness = "loudness",
  Moods = "moods",
  OriginDecade = "origin_decade",
  OriginRegion = "origin_region",
  PlayerLevel1Genres = "player_level1_genres",
  PlayerLevel2Genres = "player_level2_genres",
  Pleasantness = "pleasantness",
  RecordingEnvironment = "recording_environment",
  Rhythm = "rhythm",
  Roughness = "roughness",
  Scale = "scale",
  SongRating = "song_rating",
  SoundGeneration = "sound_generation",
  Space = "space",
  Tempo = "tempo",
  Texture = "texture",
  Timbre = "timbre",
  Tonality = "tonality",
  UseCases = "use_cases",
  Valence = "valence",
  Vocals = "vocals",
  YoutubeSafe = "youtube_safe",
}

export type SearchFilterOutput = {
  __typename?: "SearchFilterOutput";
  name: SearchFilterName;
  values: Array<Scalars["String"]["output"]>;
};

export type SearchQueries = {
  __typename?: "SearchQueries";
  /** The args passed to search */
  args: SearchArgs;
  /** Paginated list of playlists that match the search criteria */
  playlists?: Maybe<Array<Playlist>>;
  /** Search summary with total count and URL analysis */
  summary?: Maybe<SearchSummary>;
  /** Paginated list of tracks that match the search criteria */
  tracks?: Maybe<Array<Track>>;
};

export type SearchQueriesPlaylistsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  sortBy?: InputMaybe<SearchSortKey>;
  sortDirection?: InputMaybe<SearchSortDirection>;
};

export type SearchQueriesSummaryArgs = {
  similarTrackId?: InputMaybe<Scalars["String"]["input"]>;
};

export type SearchQueriesTracksArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  similarTrackId?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<SearchSortKey>;
  sortDirection?: InputMaybe<SearchSortDirection>;
};

export enum SearchSortDirection {
  Asc = "asc",
  Desc = "desc",
}

export enum SearchSortKey {
  Artist = "artist",
  BestMatch = "best_match",
  Duration = "duration",
  Name = "name",
  Quality = "quality",
  Title = "title",
}

export type SearchSummary = {
  __typename?: "SearchSummary";
  /** Similar track if the search was a similar tracks search, otherwise null */
  similarTo?: Maybe<Track>;
  /** Total number of tracks based on filters */
  total: Scalars["Int"]["output"];
  /** URL search result details if the search query was a URL and could be analyzed, otherwise null */
  urlResult?: Maybe<UrlResult>;
};

export enum SearchType {
  Reference = "REFERENCE",
  Similar = "SIMILAR",
  SmartSearch = "SMART_SEARCH",
  TracksArtists = "TRACKS_ARTISTS",
}

export enum SessionEvent {
  Clear = "Clear",
  MobileSigningInProgress = "MobileSigningInProgress",
}

export type SessionUpdate = {
  __typename?: "SessionUpdate";
  event: SessionEvent;
};

export enum ShareResourceType {
  Artist = "artist",
  Playlist = "playlist",
  Track = "track",
}

export type SharedArtistQueries = {
  __typename?: "SharedArtistQueries";
  /** Get artist details from share token */
  details?: Maybe<Artist>;
  /** Get paginated tracks for a shared artist */
  tracks?: Maybe<TracksPage>;
};

export type SharedArtistQueriesTracksArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SharedPlaylistQueries = {
  __typename?: "SharedPlaylistQueries";
  /** Get a shared playlist resolved from the request's share token */
  details?: Maybe<Playlist>;
  /** Get a shared playlist's tracks resolved from the request's share token */
  tracks?: Maybe<TracksPage>;
};

export type SharedPlaylistQueriesTracksArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SignatoryCreateResponse = {
  __typename?: "SignatoryCreateResponse";
  signatoryCompanyName?: Maybe<Scalars["String"]["output"]>;
  signatoryFirstName: Scalars["String"]["output"];
  signatoryId: Scalars["String"]["output"];
  signatoryLastName: Scalars["String"]["output"];
  signatoryUrl: Scalars["String"]["output"];
};

export enum SignatoryStatus {
  Declined = "Declined",
  Expired = "Expired",
  Pending = "Pending",
  Signed = "Signed",
}

export type SignatureDocument = {
  __typename?: "SignatureDocument";
  declineRedirectUrl?: Maybe<Scalars["String"]["output"]>;
  documentId: Scalars["String"]["output"];
  hideWelcomeDialog?: Maybe<Scalars["Boolean"]["output"]>;
  pdfBase64: Scalars["String"]["output"];
  sessionId?: Maybe<Scalars["String"]["output"]>;
  signatories: Array<SignatureDocumentSignatory>;
  status: SignatureDocumentStatus;
  successRedirectUrl?: Maybe<Scalars["String"]["output"]>;
  templateKey: Scalars["String"]["output"];
  userConfirmData?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SignatureDocumentCreateInput = {
  declineRedirectUrl?: InputMaybe<Scalars["String"]["input"]>;
  expiresInSeconds?: InputMaybe<Scalars["Int"]["input"]>;
  hideWelcomeDialog?: InputMaybe<Scalars["Boolean"]["input"]>;
  signatories: Array<SignatureDocumentSignatoryInput>;
  successRedirectUrl?: InputMaybe<Scalars["String"]["input"]>;
  templateKey: Scalars["String"]["input"];
  userConfirmData?: InputMaybe<Scalars["Boolean"]["input"]>;
  webhookUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type SignatureDocumentCreateResponse = {
  __typename?: "SignatureDocumentCreateResponse";
  documentId: Scalars["String"]["output"];
  documentUrls?: Maybe<Array<SignatoryCreateResponse>>;
};

export type SignatureDocumentDeclineInput = {
  declineReasons: Array<Scalars["String"]["input"]>;
  documentId: Scalars["String"]["input"];
  sessionId: Scalars["String"]["input"];
  signatoryId: Scalars["String"]["input"];
};

export type SignatureDocumentDeclineReason = {
  __typename?: "SignatureDocumentDeclineReason";
  reasonKey: Scalars["String"]["output"];
  reasonText: Scalars["String"]["output"];
};

export type SignatureDocumentDeclineReasonInput = {
  reasonKey: Scalars["String"]["input"];
  reasonText: Scalars["String"]["input"];
};

export type SignatureDocumentQueryInput = {
  clientInfo: Scalars["String"]["input"];
  documentId: Scalars["String"]["input"];
  mobileSigningInProgress?: InputMaybe<Scalars["Boolean"]["input"]>;
  sessionId?: InputMaybe<Scalars["String"]["input"]>;
  signatoryId: Scalars["String"]["input"];
};

export type SignatureDocumentSignInput = {
  clientInfo: Scalars["String"]["input"];
  documentId: Scalars["String"]["input"];
  sessionId: Scalars["String"]["input"];
  signatoryId: Scalars["String"]["input"];
  signatureBase64: Scalars["String"]["input"];
};

export type SignatureDocumentSignatory = {
  __typename?: "SignatureDocumentSignatory";
  companyName?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  signatoryId: Scalars["String"]["output"];
  status: SignatoryStatus;
};

export type SignatureDocumentSignatoryInput = {
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
};

export type SignatureDocumentSignatoryUpdateInput = {
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  documentId: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  signatoryId: Scalars["String"]["input"];
};

export type SignatureDocumentSignatoryUpdateResponse = {
  __typename?: "SignatureDocumentSignatoryUpdateResponse";
  documentId: Scalars["String"]["output"];
  signatoryId: Scalars["String"]["output"];
};

export enum SignatureDocumentStatus {
  Declined = "Declined",
  Expired = "Expired",
  Pending = "Pending",
  Signed = "Signed",
}

export type SignatureDocumentTemplate = {
  __typename?: "SignatureDocumentTemplate";
  declineReasons: Array<SignatureDocumentDeclineReason>;
  description: Scalars["String"]["output"];
  internalNotificationEmails?: Maybe<Array<Scalars["String"]["output"]>>;
  templateKey: Scalars["String"]["output"];
};

export type SignatureDocumentTemplateCreateInput = {
  declineReasons: Array<SignatureDocumentDeclineReasonInput>;
  description: Scalars["String"]["input"];
  internalNotificationEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  pdfUrl: Scalars["String"]["input"];
  templateKey: Scalars["String"]["input"];
};

export enum SortDirection {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
  None = "NONE",
}

export type SsoUser = {
  __typename?: "SsoUser";
  /** Email address */
  email: Scalars["String"]["output"];
  /** Full name */
  fullName: Scalars["String"]["output"];
  /** User sub (cognito ID) */
  userSub: Scalars["ID"]["output"];
};

export type Statement = {
  __typename?: "Statement";
  /** Statement details */
  details: Array<StatementDetail>;
  /** Statement ID */
  id: Scalars["String"]["output"];
  /** Statement additional information */
  information?: Maybe<Scalars["String"]["output"]>;
  /** Statement issued date */
  issued: Scalars["DateTime"]["output"];
  /** Statement net revenue */
  netRevenue: Scalars["Float"]["output"];
  /** Organization ID */
  orgId: Scalars["String"]["output"];
  /** Organization name (resolved via SSO) */
  orgName?: Maybe<Scalars["String"]["output"]>;
  /** Statement payment */
  payment: StatementPayment;
  /** Statement period */
  period: Array<Scalars["DateTime"]["output"]>;
  /** Statement report */
  report: StatementReport;
  /** Statement service (ex. YouTube) */
  service: Scalars["String"]["output"];
  /** Statement source */
  source: StatementSource;
};

export type StatementCreateInput = {
  /** Statement details */
  details: Array<StatementDetailCreateInput>;
  /** Statement ID */
  id: Scalars["String"]["input"];
  /** Statement additional information */
  information?: InputMaybe<Scalars["String"]["input"]>;
  /** Statement issued date */
  issued: Scalars["DateTime"]["input"];
  /** Statement net revenue */
  netRevenue: Scalars["Float"]["input"];
  /** Organization ID */
  orgId: Scalars["String"]["input"];
  /** Statement payment */
  payment: StatementPaymentCreateInput;
  /** Statement period */
  period: Array<Scalars["DateTime"]["input"]>;
  /** Statement report */
  report: StatementReportCreateInput;
  /** Statement service */
  service: Scalars["String"]["input"];
  /** Statement source */
  source: StatementSourceCreateInput;
};

export type StatementDetail = {
  __typename?: "StatementDetail";
  /** Detail label */
  label: Scalars["String"]["output"];
  /** Detail value */
  value: Scalars["String"]["output"];
};

export type StatementDetailCreateInput = {
  /** Detail label */
  label: Scalars["String"]["input"];
  /** Detail value */
  value: Scalars["String"]["input"];
};

export type StatementImportBatch = {
  __typename?: "StatementImportBatch";
  /** Batch creation date */
  createDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** User who created the batch */
  createUser?: Maybe<SsoUser>;
  /** Currency of the file */
  currency: Scalars["String"]["output"];
  /** Error message when the batch failed */
  error?: Maybe<Scalars["String"]["output"]>;
  /** Original file name */
  fileName: Scalars["String"]["output"];
  /** Import format the file was processed with */
  format: ImportFormat;
  /** Batch ID */
  id: Scalars["String"]["output"];
  /** Whether a Parsing/Generating batch has stopped updating (crashed) and can be recovered */
  isStale: Scalars["Boolean"]["output"];
  /** Distinct period IDs found in the file */
  periodIds: Array<Scalars["String"]["output"]>;
  /** Current counts/amounts of included rows (computed live) */
  selection?: Maybe<StatementImportSelection>;
  /** File rows left out because they have no numeric SongtradrUserID */
  skippedRows: Array<StatementImportSkippedRow>;
  /** Batch lifecycle status */
  status: ImportBatchStatus;
  /** Parse-time totals */
  totals: StatementImportTotals;
  /** Non-fatal warnings collected while processing */
  warnings: Array<Scalars["String"]["output"]>;
};

export type StatementImportCreateBatchInput = {
  /** S3 key of the uploaded file */
  fileKey: Scalars["String"]["input"];
  /** Original file name */
  fileName: Scalars["String"]["input"];
  /** Import format to process the file with */
  format: ImportFormat;
};

export type StatementImportData = {
  __typename?: "StatementImportData";
  /** Royalty balance */
  amount: Scalars["Float"]["output"];
  /** Beneficiary code from the file */
  beneficiaryCode: Scalars["String"]["output"];
  /** Matched company name */
  companyName?: Maybe<Scalars["String"]["output"]>;
  /** Row currency */
  currency: Scalars["String"]["output"];
  /** Matched contact email */
  emailAddress?: Maybe<Scalars["String"]["output"]>;
  /** External user id from the file (source company id) */
  externalUserId: Scalars["Int"]["output"];
  /** Data row ID */
  id: Scalars["String"]["output"];
  /** Whether the row is included in generation/payment */
  included: Scalars["Boolean"]["output"];
  /** Matched organization id */
  matchedOrgId?: Maybe<Scalars["String"]["output"]>;
  /** Accounting period id from the file */
  periodId: Scalars["String"]["output"];
  /** Generated statement id */
  statementId?: Maybe<Scalars["String"]["output"]>;
  /** Statement reference from the file */
  statementReference?: Maybe<Scalars["String"]["output"]>;
  /** Row lifecycle status */
  status: ImportDataStatus;
};

export type StatementImportDataPage = {
  __typename?: "StatementImportDataPage";
  /** List of import data rows */
  items: Array<StatementImportData>;
  /** Sum of amounts of all rows matching the filter */
  totalAmount: Scalars["Float"]["output"];
  /** Total number of rows matching the filter */
  totalCount: Scalars["Int"]["output"];
};

export type StatementImportDataSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<StatementImportDataSortKey>;
};

export enum StatementImportDataSortKey {
  Amount = "amount",
  BeneficiaryCode = "beneficiaryCode",
  PeriodId = "periodId",
  Status = "status",
}

export type StatementImportQueries = {
  __typename?: "StatementImportQueries";
  /** Single statement import batch */
  batch?: Maybe<StatementImportBatch>;
  /** Statement import batches, newest first */
  batches?: Maybe<Array<StatementImportBatch>>;
  /** Data rows of a statement import batch */
  data?: Maybe<StatementImportDataPage>;
};

export type StatementImportQueriesBatchArgs = {
  id: Scalars["String"]["input"];
};

export type StatementImportQueriesBatchesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type StatementImportQueriesDataArgs = {
  batchId: Scalars["String"]["input"];
  includedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sortBy?: InputMaybe<StatementImportDataSort>;
  statuses?: InputMaybe<Array<ImportDataStatus>>;
};

export type StatementImportSelection = {
  __typename?: "StatementImportSelection";
  /** Total amount of included rows pending statement generation */
  generateAmount: Scalars["Float"]["output"];
  /** Included rows pending statement generation */
  generateCount: Scalars["Int"]["output"];
  /** Rows whose statement has been paid */
  paidCount: Scalars["Int"]["output"];
  /** Total amount of included rows with a statement, pending payment */
  payAmount: Scalars["Float"]["output"];
  /** Included rows with a statement, pending payment */
  payCount: Scalars["Int"]["output"];
  /** Rows with a generated statement (any payment state, included or not) */
  statementCount: Scalars["Int"]["output"];
};

export type StatementImportSkippedRow = {
  __typename?: "StatementImportSkippedRow";
  /** Royalty balance */
  amount: Scalars["Float"]["output"];
  /** Beneficiary code from the file */
  beneficiaryCode: Scalars["String"]["output"];
  /** Row number in the file */
  rowNumber: Scalars["Int"]["output"];
};

export type StatementImportTotals = {
  __typename?: "StatementImportTotals";
  /** Rows matched to an org via a source connection */
  matchedCount: Scalars["Int"]["output"];
  /** Number of data rows in the file */
  rowCount: Scalars["Int"]["output"];
  /** Sum of all royalty balances */
  totalAmount: Scalars["Float"]["output"];
  /** Rows without a matching source connection */
  unmatchedCount: Scalars["Int"]["output"];
  /** Rows with a zero royalty balance */
  zeroBalanceCount: Scalars["Int"]["output"];
};

export type StatementPage = {
  __typename?: "StatementPage";
  /** List of statements */
  items: Array<Statement>;
  /** Total number of statements */
  total: Scalars["Int"]["output"];
};

export type StatementPayment = {
  __typename?: "StatementPayment";
  /** Payment date */
  date?: Maybe<Scalars["DateTime"]["output"]>;
  /** Payment status */
  status: StatementPaymentStatus;
};

export type StatementPaymentCreateInput = {
  /** Payment date */
  date?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Payment status; Pending is derived from payouts and rejected here */
  status: StatementPaymentStatus;
};

export enum StatementPaymentStatus {
  Adjustment = "Adjustment",
  Paid = "Paid",
  /** In a payout that hasn't been paid yet */
  Pending = "Pending",
  /** Paid out, then returned by Trolley; its amount is back in the balance */
  Returned = "Returned",
  Unpaid = "Unpaid",
}

export type StatementReport = {
  __typename?: "StatementReport";
  /** Report file object */
  file?: Maybe<StatementReportFile>;
  /** Report file source URL */
  sourceUrl: Scalars["String"]["output"];
};

export type StatementReportCreateInput = {
  /** Report file object */
  file: StatementReportFileCreateInput;
  /** Report file source URL */
  sourceUrl: Scalars["String"]["input"];
};

export type StatementReportFile = {
  __typename?: "StatementReportFile";
  /** File extension */
  extension: Scalars["String"]["output"];
  /** S3 file key */
  key: Scalars["String"]["output"];
  /** Temporary URL */
  temporaryUrl?: Maybe<Scalars["String"]["output"]>;
};

export type StatementReportFileCreateInput = {
  /** File extension */
  extension: Scalars["String"]["input"];
};

export type StatementSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Sort key */
  key?: InputMaybe<StatementSortKey>;
};

export enum StatementSortKey {
  Issued = "issued",
  NetRevenue = "netRevenue",
  Period = "period",
}

export type StatementSource = {
  __typename?: "StatementSource";
  /** Source ID */
  id: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type StatementSourceCreateInput = {
  /** Source app ID */
  id: Scalars["String"]["input"];
  /** Source app type */
  type: Scalars["String"]["input"];
};

export type StatementUpdateInput = {
  /** Statement details */
  details?: InputMaybe<Array<InputMaybe<StatementDetailCreateInput>>>;
  /** Statement ID */
  id: Scalars["String"]["input"];
  /** Statement additional information */
  information?: InputMaybe<Scalars["String"]["input"]>;
  /** Statement issued date */
  issued?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Statement net revenue */
  netRevenue?: InputMaybe<Scalars["Float"]["input"]>;
  /** Organization ID */
  orgId: Scalars["String"]["input"];
  /** Statement payment */
  payment?: InputMaybe<StatementPaymentCreateInput>;
  /** Statement period */
  period?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  /** Statement service */
  service?: InputMaybe<Scalars["String"]["input"]>;
  /** Statement source */
  source?: InputMaybe<StatementSourceCreateInput>;
};

export type Stem = {
  __typename?: "Stem";
  /** Requested output format */
  format: StemOutputFormat;
  /** Stem record ID */
  id: Scalars["ID"]["output"];
  /** Provider-agnostic model identifier */
  modelId: Scalars["String"]["output"];
  /** Provider task ID */
  providerTaskId: Scalars["ID"]["output"];
  /** Our S3 object key once the file has been persisted */
  s3Key?: Maybe<Scalars["String"]["output"]>;
  /** Current processing status */
  status: StemStatus;
  /** Source track ID */
  trackId: Scalars["ID"]["output"];
};

export enum StemOutputFormat {
  Mp3 = "mp3",
  Wav = "wav",
}

export enum StemStatus {
  Completed = "completed",
  Error = "error",
  Processing = "processing",
}

export type StemsQueries = {
  __typename?: "StemsQueries";
  /** Get stems by id */
  byId?: Maybe<Array<Stem>>;
};

export type StemsQueriesByIdArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type Subscription = {
  __typename?: "Subscription";
  documentUpdated: Scalars["Boolean"]["output"];
  newNotification: Scalars["Boolean"]["output"];
  sessionUpdated?: Maybe<SessionUpdate>;
};

export type SubscriptionDocumentUpdatedArgs = {
  documentId: Scalars["String"]["input"];
  signatoryId: Scalars["String"]["input"];
};

export type SubscriptionSessionUpdatedArgs = {
  sessionId: Scalars["String"]["input"];
};

export type TikTokOembed = {
  __typename?: "TikTokOembed";
  html?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type Track = {
  __typename?: "Track";
  /** Track characteristics derived from tag strengths */
  analysis?: Maybe<TrackAnalysis>;
  /** Track artist */
  artists: Array<Artist>;
  /** Track URL */
  audioUrls: AudioUrls;
  /** Track Curator */
  curator?: Maybe<Curator>;
  /** Get track to download by id */
  downloadLink?: Maybe<Scalars["String"]["output"]>;
  /** Track Duration */
  duration: Scalars["Int"]["output"];
  /** Track genres */
  genres: Scalars["String"]["output"];
  /** Track ID */
  id: Scalars["ID"]["output"];
  /** Track Image GUID */
  imageGuid?: Maybe<Scalars["String"]["output"]>;
  /** Track Image URL */
  imageUrl: Scalars["String"]["output"];
  /**
   * Legacy data
   * @deprecated Field no longer supported
   */
  legacy?: Maybe<TrackLegacy>;
  /** Album or release associated with the track, if available */
  release?: Maybe<Release>;
  /** Per-moment energy intensity samples across the track's duration, used to draw the dynamic overlay on its waveform */
  taggrams?: Maybe<Array<TrackTaggram>>;
  /** Track title */
  title: Scalars["String"]["output"];
  /** Track Traits */
  traits: TrackTraits;
  /** Track type - null for a base track, set for variants like stems */
  type?: Maybe<TrackType>;
  /** Current User's Track Metadata */
  userMeta?: Maybe<TrackUserMeta>;
  /** Track Waveform */
  waveform: Waveform;
  /** Track Waveform URL */
  waveformUrl?: Maybe<Scalars["String"]["output"]>;
};

export type TrackDownloadLinkArgs = {
  source?: InputMaybe<UserActionLogSource>;
  sourceId?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<DownloadType>;
};

export type TrackImageUrlArgs = {
  size?: InputMaybe<Scalars["String"]["input"]>;
};

export type TrackAnalysis = {
  __typename?: "TrackAnalysis";
  characteristics: TrackCharacteristics;
  visuals: TrackVisuals;
};

export type TrackCharacteristics = {
  __typename?: "TrackCharacteristics";
  ageAffinity?: Maybe<Array<Scalars["String"]["output"]>>;
  bpm?: Maybe<Scalars["Int"]["output"]>;
  decade?: Maybe<Scalars["String"]["output"]>;
  genderAffinity?: Maybe<Scalars["String"]["output"]>;
  genre?: Maybe<Scalars["String"]["output"]>;
  instruments?: Maybe<Array<Scalars["String"]["output"]>>;
  key?: Maybe<Scalars["String"]["output"]>;
  mood?: Maybe<Array<Scalars["String"]["output"]>>;
  regionAffinity?: Maybe<Array<Scalars["String"]["output"]>>;
  tempo?: Maybe<Scalars["String"]["output"]>;
  useCasePredictions?: Maybe<Array<Scalars["String"]["output"]>>;
  vocals?: Maybe<Scalars["String"]["output"]>;
};

export type TrackLegacy = {
  __typename?: "TrackLegacy";
  liked?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum TrackSortDirection {
  Asc = "asc",
  Desc = "desc",
}

export enum TrackSortKey {
  Title = "title",
}

export type TrackTaggram = {
  __typename?: "TrackTaggram";
  intensity: Scalars["Float"]["output"];
  key: Scalars["String"]["output"];
};

export type TrackTraits = {
  __typename?: "TrackTraits";
  explicit?: Maybe<Scalars["Boolean"]["output"]>;
  vocals?: Maybe<Scalars["Boolean"]["output"]>;
  youtubeSafe?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum TrackType {
  Stem = "stem",
}

export type TrackUserMeta = {
  __typename?: "TrackUserMeta";
  /** Liked by current user */
  liked?: Maybe<Scalars["Boolean"]["output"]>;
};

export type TrackVisualDataPoint = {
  __typename?: "TrackVisualDataPoint";
  label: Scalars["String"]["output"];
  value: Scalars["Int"]["output"];
};

export type TrackVisuals = {
  __typename?: "TrackVisuals";
  ageAffinity: Array<TrackVisualDataPoint>;
  genderAffinity: Array<TrackVisualDataPoint>;
  genres: Array<TrackVisualDataPoint>;
  moods: Array<TrackVisualDataPoint>;
  regionAffinity: Array<TrackVisualDataPoint>;
  subGenres: Array<TrackVisualDataPoint>;
};

export type TracksPage = {
  __typename?: "TracksPage";
  items: Array<Track>;
  total: Scalars["Int"]["output"];
};

export type TracksQueries = {
  __typename?: "TracksQueries";
  /** Get list of tracks by id */
  byId?: Maybe<Array<Track>>;
  /** Get downloaded tracks for the current user, or for the whole organization */
  downloaded?: Maybe<TracksPage>;
  /** Get featured tracks */
  featured?: Maybe<Array<Track>>;
  /** Get liked tracks for the current user */
  liked?: Maybe<TracksPage>;
  /** Get recently played tracks for the current user */
  recent?: Maybe<TracksPage>;
  /** Get similar tracks to a track */
  similar?: Maybe<Array<Track>>;
};

export type TracksQueriesByIdArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type TracksQueriesDownloadedArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  scope?: InputMaybe<DownloadsScope>;
  sort?: InputMaybe<Scalars["String"]["input"]>;
};

export type TracksQueriesFeaturedArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TracksQueriesLikedArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Scalars["String"]["input"]>;
};

export type TracksQueriesRecentArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Scalars["String"]["input"]>;
};

export type TracksQueriesSimilarArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  trackId: Scalars["ID"]["input"];
};

export type UpdateClientInput = {
  /** Client contact */
  contact: Scalars["String"]["input"];
  /** Client email */
  email: Scalars["String"]["input"];
  /** Client ID */
  id: Scalars["ID"]["input"];
  /** Client name */
  name: Scalars["String"]["input"];
};

export type UpdateIngestionJobInput = {
  csvOriginalFilename?: InputMaybe<Scalars["String"]["input"]>;
  dromoImportId?: InputMaybe<Scalars["String"]["input"]>;
  dromoImportIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  dromoSessionId?: InputMaybe<Scalars["String"]["input"]>;
  jobId: Scalars["ID"]["input"];
  jobName?: InputMaybe<Scalars["String"]["input"]>;
  licensorDpid?: InputMaybe<Scalars["String"]["input"]>;
  mappingSnapshot?: InputMaybe<Scalars["JSON"]["input"]>;
  mediaFiles?: InputMaybe<Array<SavedMediaFileInput>>;
  metadataRowCount?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<IngestionJobStatus>;
};

export type UpdateLegalDocumentInput = {
  confirmations?: InputMaybe<Array<LegalConfirmationInput>>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  effectiveDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  requiresReagreement?: InputMaybe<Scalars["Boolean"]["input"]>;
  requiresScrollToAccept?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateLegalDocumentVariantInput = {
  name: Scalars["String"]["input"];
  /** Full set of orgs for the version */
  orgIds: Array<Scalars["ID"]["input"]>;
};

export type UpdateOrgDetailsInput = {
  metadata: UpdateOrgDetailsMetadataInput;
  /** Org name */
  name: Scalars["String"]["input"];
  /** Parent Org ID */
  parentOrgId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UpdateOrgDetailsMetadataInput = {
  accountManagerEmail: Scalars["String"]["input"];
  accountManagerFirstName: Scalars["String"]["input"];
  accountManagerLastName: Scalars["String"]["input"];
  accountManagerPhone?: InputMaybe<Scalars["String"]["input"]>;
  /** Analytics Heap enabled */
  analyticsHeapEnabled: Scalars["Boolean"]["input"];
  basicDealId: Scalars["ID"]["input"];
  basicHoldingOrgId?: InputMaybe<Scalars["ID"]["input"]>;
  basicServicingOrgEmail: Scalars["String"]["input"];
  basicServicingOrgId: Scalars["ID"]["input"];
  /** Org HubSpot IDs. Used to link the org to it's counterpart in the HubSpot system. */
  hubSpotIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Org billing email address */
  payoutsBillingEmail?: InputMaybe<Scalars["String"]["input"]>;
  /** Minimum payout in USD cents, at least the platform minimum. Null resets it to the default; omitted keeps it. */
  payoutsMinimumPayoutCents?: InputMaybe<Scalars["Int"]["input"]>;
  /** Org Trolley reference ID. Custom identifier that can be assigned to an entity when creating it within Trolley's system. By default, it is the same as the organization ID. */
  payoutsTrolleyRefId: Scalars["ID"]["input"];
  priceEstimationCurrency?: InputMaybe<Scalars["Currency"]["input"]>;
  priceEstimationInstagramFollowers?: InputMaybe<Scalars["Int"]["input"]>;
  priceEstimationMarketCap?: InputMaybe<Scalars["Int"]["input"]>;
  priceEstimationMarketSymbol?: InputMaybe<Scalars["String"]["input"]>;
  priceEstimationNumberOfEmployees?: InputMaybe<Scalars["Int"]["input"]>;
  priceEstimationPublicCompany?: InputMaybe<Scalars["Boolean"]["input"]>;
  priceEstimationTikTokFollowers?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateOrgModulesInput = {
  /** List of modules to be enabled for the organization */
  modules: Array<UpdateOrgModulesModuleInput>;
};

export type UpdateOrgModulesModuleInput = {
  name: Scalars["String"]["input"];
  value: Scalars["Boolean"]["input"];
};

export type UrlResult = {
  __typename?: "UrlResult";
  /** Artists of the track if the search was a URL search and the artists could be extracted */
  artists?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Platform specific identifier for the track (e.g. Spotify ID, YouTube ID) */
  id?: Maybe<Scalars["String"]["output"]>;
  /** International Standard Recording Code of the track */
  isrc?: Maybe<Scalars["String"]["output"]>;
  /** Title of the track if the search was a URL search and the title could be extracted */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Type of URL (e.g. Spotify, YouTube) */
  type?: Maybe<Scalars["String"]["output"]>;
  /** The original URL that was searched */
  url: Scalars["String"]["output"];
};

export enum UrlType {
  Spotify = "Spotify",
  YouTube = "YouTube",
}

export enum UserActionLogSource {
  Artist = "ARTIST",
  CuratedPlaylist = "CURATED_PLAYLIST",
  Library = "LIBRARY",
  Other = "OTHER",
  Playlist = "PLAYLIST",
  Search = "SEARCH",
}

export type UserOrg = {
  __typename?: "UserOrg";
  /** Org ID */
  id: Scalars["ID"]["output"];
  /** Org name */
  name: Scalars["String"]["output"];
  /** Parent Org ID */
  parentOrgId?: Maybe<Scalars["ID"]["output"]>;
  /** Workspace */
  workspace?: Maybe<Scalars["String"]["output"]>;
};

export enum UserPlaylistsSortDirection {
  Asc = "asc",
  Desc = "desc",
}

export enum UserPlaylistsSortKey {
  Name = "name",
}

/** The current org's subscription (not the user's own), whichever system bills it */
export type UserSubscription = {
  __typename?: "UserSubscription";
  /** Whether the org's subscription is currently active */
  isActive: Scalars["Boolean"]["output"];
  /** External page to view and manage the org's subscription; null when it is not self-managed */
  manageUrl?: Maybe<Scalars["String"]["output"]>;
  /** Plan in force for the org, e.g. Songtradr PRO; null without an active plan */
  name?: Maybe<Scalars["String"]["output"]>;
  /** System billing the org's subscription */
  provider: UserSubscriptionProvider;
  /** Plans the org can subscribe to; empty while its subscription is active */
  subscribePlans: Array<UserSubscriptionPlan>;
};

/** How an add-on's price tiers add up */
export enum UserSubscriptionAddOnPricing {
  /** Every unit at one price */
  Flat = "flat",
  /** The price of the tier the total quantity falls in, as a whole */
  Stairstep = "stairstep",
  /** Each unit at the price of the tier it falls in */
  Tiered = "tiered",
  /** Every unit at the price of the tier the total quantity falls in */
  Volume = "volume",
}

/** Price per unit up to a quantity */
export type UserSubscriptionAddOnTier = {
  __typename?: "UserSubscriptionAddOnTier";
  /** Last quantity at this price; null when unbounded */
  endingQuantity?: Maybe<Scalars["Int"]["output"]>;
  /** Price per unit, in the plan's currency */
  unitAmount: Scalars["Float"]["output"];
};

/** A plan the org can subscribe to on an external checkout page */
export type UserSubscriptionPlan = {
  __typename?: "UserSubscriptionPlan";
  /** Number of artists to distribute, chosen before checkout; null when the plan has a fixed number */
  artistsAddOn?: Maybe<UserSubscriptionPlanAddOn>;
  /** Months per billing period, e.g. 1 or 12; null when not month-based */
  billingMonths?: Maybe<Scalars["Int"]["output"]>;
  /** ISO 4217 currency of the price, e.g. USD */
  currency?: Maybe<Scalars["String"]["output"]>;
  /** Number of artists the plan covers at most; null when unknown */
  maxArtists?: Maybe<Scalars["Int"]["output"]>;
  /** Plan name, e.g. Songtradr Pro - Monthly */
  name: Scalars["String"]["output"];
  /** Price per billing period before add-ons and tax; null when unknown */
  price?: Maybe<Scalars["Float"]["output"]>;
  /** External checkout page subscribing the org to this plan (add-on quantities go in its query string) */
  subscribeUrl: Scalars["String"]["output"];
};

/** A quantity-priced add-on chosen before checkout, e.g. the number of artists */
export type UserSubscriptionPlanAddOn = {
  __typename?: "UserSubscriptionPlanAddOn";
  /** Add-on code the checkout page expects */
  code: Scalars["String"]["output"];
  /** Quantity to start with */
  defaultQuantity: Scalars["Int"]["output"];
  /** Largest quantity that can be chosen */
  maxQuantity: Scalars["Int"]["output"];
  /** How the tiers add up */
  pricing: UserSubscriptionAddOnPricing;
  /** Price tiers, ascending by quantity */
  tiers: Array<UserSubscriptionAddOnTier>;
};

/** The system a subscription is billed in */
export enum UserSubscriptionProvider {
  /** Legacy marketplace subscription, carried over from before the migration */
  LegacyMarketplace = "LegacyMarketplace",
}

export type ValidateFilesInput = {
  catalogUploadId: Scalars["String"]["input"];
  filenames: Array<Scalars["String"]["input"]>;
};

export type Waveform = {
  __typename?: "Waveform";
  data: Array<Scalars["Int"]["output"]>;
  length: Scalars["Int"]["output"];
};

export type YouTubeChannelMetadata = {
  __typename?: "YouTubeChannelMetadata";
  canonical?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  image?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};
